import React from "react";
// import ReactDOM from 'react-dom';
import ReactDOM from 'react-dom/client';
import "./UI/andarBahars.css";
import { Howl } from "howler";
import ChipsDealerPlayer from "./UI/AB_ChipsDealerPlayer";
import TopLable from "./UI/topLable";
import betSound from "../../../../../assets/sounds/bet.mp3";
import takeSound from "../../../../../assets/sounds/take.mp3";
import winSound from "../../../../../assets/sounds/win.mp3";
import close from "../../../../../assets/sounds/exit.mp3";
import betoncard from "../../../../../assets/sounds/betoncard.mp3";
import clearSound from "../../../../../assets/sounds/clear.mp3";
import ad_bg_img from '../../../../../assets/games/andarBaharTimer/ab_bg.png'
import { connect } from "react-redux";
import BetPlacedChip from "../../../../../library/Chips/BetChip";
import welComeGif from "../../../../../assets/games/AB_Classic/sprite.webp"
import welComeAudio from "../../../../../assets/games/AB_Classic/welComeAudio.mp3"



class AndarBaharClassic extends React.Component {
  constructor(props) {
    super(props);
    this.ChipsDealerPlayer = React.createRef();
    this.TopLable = React.createRef();
    this.VideoRef = React.createRef();
    this.state = {
      chipVal: 1,
      betAmt: 0,
      betCard: null,
      betCount: 0,
      //takeAmt: 0,
      delearFirst: true,
      infoText: this.props.language.AmusementOnly,
      cardsArray: "",
      betAmountArray: "",
      winnerArray: "",
      betButtonText: this.props.language.Prev,
      betButtonValue: 0,
      btnActive: false,
      disable: true,
      disableDealBtn: true,
      disableClearBtn: true,
      targetResult: [],
      totalBetAmount: 0,
      totalabbet: 0,
      takeAmount: 0,
      disableBetBtn: true,
      isGameActive: true,
      isBetSent: false,
      startBlink: false,
      maxInnerValue: 0,
      enableKeyboard: false,
      winGlowImg: false,
      showVideo: false,
      isPlayingBet: false,
      backGroundX: 0,
      backGroundY: 0,
      welComeSpriteImage: null,
      isCardsDealing: false
    };
    this.takeSound = new Audio(takeSound);
    this.close = new Audio(close);
    this.winSound = new Audio(winSound);
    this.betSound = new Audio(betSound);
    // this.betoncard = new Audio(betoncard);
    this.betoncard = this.initializeBetSound();
    this.clearSound = new Audio(clearSound);
    this.betPlaced = false;
    this.resultShown = false;
    this.handId = 0;
    this.isSpectSent = false;
    this.backgroudFrame = 0;
    this.backgroudFrame = 0;
    this.cardBetAmt = 0;
    this.cardBet = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.cardBetlblchange = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.suitBet = [0, 0, 0, 0];
    this.numBet = [0, 0];
    this.abBet = [0, 0];
    this.ab_betString = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.innerLimits = {};
    this.playVideo = this.playVideo.bind(this);
    this.stopVideo = this.stopVideo.bind(this);
    this.welComeSpriteImage = new Image();
    this.welComeVideoAudio = new Howl({ src: welComeAudio, html5: true, preload: true });
    this.isSpritePlaying = false
    this.spriteInterval = null
  }
  initializeBetSound = () => {
    try {
      const betSound = new Howl({
        src: [betoncard],
        html5: true, // Enable HTML5 Audio for mobile compatibility
      });
      this.setState({
        betoncard,
        isPlayingBet: false,
      });
      return betSound;
    } catch (error) {
      console.error("Error initializing bet sound:", error);
      return null;
    }
  };

  playPokerBetSound = (chipSound) => {

    const { isPlayingBet } = this.state;
    let currentSound = chipSound;
    try {


      if (isPlayingBet && chipSound) {
        chipSound.stop();
      }
      if (!chipSound) {
        currentSound = this.initializeBetSound();
      }
      if (currentSound) {

        currentSound.play();
        this.setState({
          isPlayingBet: true,
        });
      } else {
        console.error("Invalid sound object. Unable to play sound.");
      }
    } catch (error) {
      console.error("Invalid sound object. Unable to play sound.", error);
    }

  };

  componentDidMount() {
    // const { childRef } = this.props;
    // childRef(this);
    this.ab_timeout1 = null;
    this.ab_timeout2 = null;
    this.ab_timeout3 = null;
    this.ab_timeout4 = null;
    this.ab_timeout5 = null;
    this.ab_timeout6 = null;
    this.ab_timeout7 = null;
    this.ab_timeout8 = null;
    this.ab_timeout9 = null;
    this.ab_ch_timeout13 = null;

    // this.preloadAssets();
    let spriteImage = new Image()
    spriteImage.src = welComeGif

    this.welComeSpriteImage.src = welComeGif

    if (this.props.abt_innerLimits && this.props.abt_innerLimits.length > 0) {
      this.innerLimits = this.props.abt_innerLimits.split("|");
      for (let t = 0; t < this.innerLimits.length; t++) {
        this.innerLimits[t] = this.innerLimits[t].split("-");
      }
    }

    let responseChips = this.props.abt_chipValues.split(",");


    // if (this.props.maxBetAmt < 10) {
    if (this.props.maxBetAmt < Number(responseChips[0])) {
      document.getElementById("chipImg_10").style.opacity = 0.5;
      document.getElementById("chipImg_10").style.pointerEvents = 'none';
      document.getElementById("chipImg_25").style.opacity = 0.5;
      document.getElementById("chipImg_25").style.pointerEvents = 'none';
      document.getElementById("chipImg_50").style.opacity = 0.5;
      document.getElementById("chipImg_50").style.pointerEvents = 'none';
      document.getElementById("chipImg_100").style.opacity = 0.5;
      document.getElementById("chipImg_100").style.pointerEvents = 'none';
      document.getElementById("chipImg_500").style.opacity = 0.5;
      document.getElementById("chipImg_500").style.pointerEvents = 'none';
      document.getElementById("chipImg_1000").style.opacity = 0.5;
      document.getElementById("chipImg_1000").style.pointerEvents = 'none';
      document.getElementById("chipImg_5000").style.opacity = 0.5;
      document.getElementById("chipImg_5000").style.pointerEvents = 'none';

      // } else if (this.props.maxBetAmt < 25) {
    } else if (this.props.maxBetAmt < Number(responseChips[1])) {
      document.getElementById("chipImg_25").style.opacity = 0.5;
      document.getElementById("chipImg_25").style.pointerEvents = 'none';
      document.getElementById("chipImg_50").style.opacity = 0.5;
      document.getElementById("chipImg_50").style.pointerEvents = 'none';
      document.getElementById("chipImg_100").style.opacity = 0.5;
      document.getElementById("chipImg_100").style.pointerEvents = 'none';
      document.getElementById("chipImg_500").style.opacity = 0.5;
      document.getElementById("chipImg_500").style.pointerEvents = 'none';
      document.getElementById("chipImg_1000").style.opacity = 0.5;
      document.getElementById("chipImg_1000").style.pointerEvents = 'none';
      document.getElementById("chipImg_5000").style.opacity = 0.5;
      document.getElementById("chipImg_5000").style.pointerEvents = 'none';
      // } else if (this.props.maxBetAmt < 50) {
    } else if (this.props.maxBetAmt < Number(responseChips[2])) {
      document.getElementById("chipImg_50").style.opacity = 0.5;
      document.getElementById("chipImg_50").style.pointerEvents = 'none';
      document.getElementById("chipImg_100").style.opacity = 0.5;
      document.getElementById("chipImg_100").style.pointerEvents = 'none';
      document.getElementById("chipImg_500").style.opacity = 0.5;
      document.getElementById("chipImg_500").style.pointerEvents = 'none';
      document.getElementById("chipImg_1000").style.opacity = 0.5;
      document.getElementById("chipImg_1000").style.pointerEvents = 'none';
      document.getElementById("chipImg_5000").style.opacity = 0.5;
      document.getElementById("chipImg_5000").style.pointerEvents = 'none';

      // } else if (this.props.maxBetAmt < 100) {
    } else if (this.props.maxBetAmt < Number(responseChips[3])) {
      document.getElementById("chipImg_100").style.opacity = 0.5;
      document.getElementById("chipImg_100").style.pointerEvents = 'none';
      document.getElementById("chipImg_500").style.opacity = 0.5;
      document.getElementById("chipImg_500").style.pointerEvents = 'none';
      document.getElementById("chipImg_1000").style.opacity = 0.5;
      document.getElementById("chipImg_1000").style.pointerEvents = 'none';
      document.getElementById("chipImg_5000").style.opacity = 0.5;
      document.getElementById("chipImg_5000").style.pointerEvents = 'none';

      // } else if (this.props.maxBetAmt < 500) {
    } else if (this.props.maxBetAmt < Number(responseChips[4])) {

      document.getElementById("chipImg_500").style.opacity = 0.5;
      document.getElementById("chipImg_500").style.pointerEvents = 'none';
      document.getElementById("chipImg_1000").style.opacity = 0.5;
      document.getElementById("chipImg_1000").style.pointerEvents = 'none';
      document.getElementById("chipImg_5000").style.opacity = 0.5;
      document.getElementById("chipImg_5000").style.pointerEvents = 'none';

      // } else if (this.props.maxBetAmt < 1000) {
    } else if (this.props.maxBetAmt < Number(responseChips[5])) {
      document.getElementById("chipImg_1000").style.opacity = 0.5;
      document.getElementById("chipImg_1000").style.pointerEvents = 'none';
      document.getElementById("chipImg_5000").style.opacity = 0.5;
      document.getElementById("chipImg_5000").style.pointerEvents = 'none';
      // } else if (this.props.maxBetAmt < 5000) {
    } else if (this.props.maxBetAmt < Number(responseChips[6])) {
      document.getElementById("chipImg_5000").style.opacity = 0.5;
      document.getElementById("chipImg_5000").style.pointerEvents = 'none';
    }

    // document.getElementById("exitBtn").disabled = true;
    // this.ab_timeout1 = setTimeout(() => {
    //   if (document.getElementById("exitBtn")) {
    //     document.getElementById("exitBtn").disabled = false;
    //   }
    // }, 1000);


    let newChips = this.props.abt_chipValues.split(",");

    this.setState({ chipVal: Number(newChips[0]) });

    this.setState({ disableDealBtn: true, maxInnerValue: 0 })

    this.disableBtn("clearBtn");
    this.disableBtn("doubleBtn");
    this.disableBtn("betBtn");


    this.updateHistory();

    if (this.props.gameState.takeAmount > 0) {
      // document.getElementById("abc_cover").style.display = "block";

      if (document.getElementById("betBtn").classList.contains("ab_disBtn")) {
        document.getElementById("betBtn").classList.remove("ab_disBtn");
        document.getElementById("betBtn").style.zIndex = 180;
      }

      this.setState({
        totalBetAmount: this.props.gameState.betRequest.betAmount,
        totalabbet: this.props.gameState.betRequest.betAmount,
        takeAmount: this.props.gameState.takeAmount,
        infoText: this.props.language.ClickTake,
        betButtonText: this.props.language.Take,
        betButtonValue: 2,
        startBlink: true,
        disableDealBtn: false,
        winGlowImg: true,
      })

      // this.showPreviousBet();

      // let bet1 = this.props.gameState.betRequest.betString.split(",")[0];
      // const bet1_1 = bet1.split("|");
      // for (let j = 0; j < bet1_1.length; j++) {
      //   bet1_1[j] = Number(bet1_1[j])
      //   if (Number(bet1_1[j]) <= this.innerLimits[0][1]) {
      //     this.cardBet[j] = Number(bet1_1[j]);
      //     if (Number(bet1_1[j]) > 0) {
      //       this.setState({ betCard: j })
      //       this.cardBetAmt = Number(bet1_1[j]);



      //       const container = document.getElementById("fID_" + j);

      //       if (container) {
      //         // container.appendChild(<div className="abc_goldcoin " style={{ position: "relative" }}><BetPlacedChip betAmount={bet1_1[j]} chipString={this.props.abt_chipValues} gameId={24} /></div>)
      //         const root = ReactDOM.createRoot(container);
      //         root.render(<div className="abc_goldcoin " style={{ position: "relative" }}><BetPlacedChip betAmount={bet1_1[j]} chipString={this.props.abt_chipValues} gameId={24} /></div>);
      //       }



      //       // document.getElementById("fID_" + j).innerHTML = `<p class="abc_goldcoin"> <span> ${Number(bet1_1[j])} </span> </p>`;
      //       if (document.getElementById("card_" + j))
      //         document.getElementById("card_" + j).style.transform = "scale(0.9)";



      //     }
      //   } else {
      //     this.setState({ infoText: this.props.language.MaxBetLmt });
      //   }
      // }

      // let bet2 = this.props.gameState.betRequest.betString.split(",")[1];
      // const bet2_1 = bet2.split("|");

      // for (let y = 0; y < bet2_1.length; y++) {
      //   // let Changebetslbl=this.changeAmtlabl(Number(bet2_1[y]))
      //   // bet2_1[y] = Changebetslbl
      //   bet2_1[y] = Number(bet2_1[y]);
      //   if (Number(bet2_1[y]) <= this.innerLimits[1][1]) {
      //     this.suitBet[y] = Number(bet2_1[y]);
      //     if (Number(bet2_1[y]) > 0) {
      //       switch (y) {
      //         case 0:
      //           // document.getElementById("spade").innerHTML = `<p class="abc_goldcoin"> <span> ${Number(bet2_1[y])} </span> </p>`;

      //           const container = document.getElementById("spade");

      //           if (container) {
      //             // container.appendChild(<div className="abc_goldcoin " style={{ position: "relative" }}><BetPlacedChip betAmount={bet2_1[y]} chipString={this.props.abt_chipValues} gameId={24} /></div>)
      //             const root = ReactDOM.createRoot(container);
      //             root.render(<div className="abc_goldcoin " style={{ position: "relative" }}><BetPlacedChip betAmount={bet2_1[y]} chipString={this.props.abt_chipValues} gameId={24} /></div>);
      //           }
      //           break;
      //         case 1:
      //           // document.getElementById("club").innerHTML = `<p class="abc_goldcoin"> <span> ${Number(bet2_1[y])} </span> </p>`;


      //           if (document.getElementById("club")) {
      //             // document.getElementById("club").appendChild(<div className="abc_goldcoin " style={{ position: "relative" }}><BetPlacedChip betAmount={bet2_1[y]} chipString={this.props.abt_chipValues} gameId={24} /></div>)
      //             const root = ReactDOM.createRoot(document.getElementById("club"));
      //             root.render(<div className="abc_goldcoin " style={{ position: "relative" }}><BetPlacedChip betAmount={bet2_1[y]} chipString={this.props.abt_chipValues} gameId={24} /></div>);
      //           }
      //           break;
      //         case 2:
      //           // document.getElementById("dimond").innerHTML = `<p class="abc_goldcoin"> <span> ${Number(bet2_1[y])} </span> </p>`;
      //           if (document.getElementById("dimond")) {
      //             // document.getElementById("dimond").appendChild(<div className="abc_goldcoin " style={{ position: "relative" }}><BetPlacedChip betAmount={bet2_1[y]} chipString={this.props.abt_chipValues} gameId={24} /></div>)
      //             const root = ReactDOM.createRoot(document.getElementById("dimond"));
      //             root.render(<div className="abc_goldcoin " style={{ position: "relative" }}><BetPlacedChip betAmount={bet2_1[y]} chipString={this.props.abt_chipValues} gameId={24} /></div>);
      //           }
      //           break;
      //         case 3:
      //           // document.getElementById("heart").innerHTML = `<p class="abc_goldcoin"> <span> ${Number(bet2_1[y])} </span> </p>`;
      //           if (document.getElementById("heart")) {
      //             // document.getElementById("heart").appendChild(<div className="abc_goldcoin " style={{ position: "relative" }}><BetPlacedChip betAmount={bet2_1[y]} chipString={this.props.abt_chipValues} gameId={24} /></div>)
      //             const root = ReactDOM.createRoot(document.getElementById("heart"));
      //             root.render(<div className="abc_goldcoin " style={{ position: "relative" }}><BetPlacedChip betAmount={bet2_1[y]} chipString={this.props.abt_chipValues} gameId={24} /></div>);
      //           }
      //           break;
      //       }
      //     }
      //   } else {
      //     this.setState({ infoText: this.props.language.MaxBetLmt });
      //   }
      // }

      // let bet3 = this.props.gameState.betRequest.betString.split(",")[2];
      // const bet3_1 = bet3.split("|");

      // for (let t = 0; t < bet3_1.length; t++) {

      //   // let lblbets=this.changeAmtlabl(Number(bet3_1[t]))
      //   // bet3_1[t] =lblbets;
      //   bet3_1[t] = Number(bet3_1[t]);
      //   if (Number(bet3_1[t]) <= this.innerLimits[2][1]) {
      //     this.numBet[t] = Number(bet3_1[t]);
      //     if (Number(bet3_1[t]) > 0) {
      //       if (t == 0) {
      //         // document.getElementById("one_six").innerHTML = `<p class="abc_goldcoin"> <span> ${Number(bet3_1[t])} </span> </p>`;
      //         if (document.getElementById("one_six")) {
      //           // document.getElementById("one_six").appendChild(<div className="abc_goldcoin " style={{ position: "relative" }}><BetPlacedChip betAmount={bet3_1[t]} chipString={this.props.abt_chipValues} gameId={24} /></div>)
      //           const root = ReactDOM.createRoot(document.getElementById("one_six"));
      //           root.render(<div className="abc_goldcoin " style={{ position: "relative" }}><BetPlacedChip betAmount={bet3_1[t]} chipString={this.props.abt_chipValues} gameId={24} /></div>);
      //         }
      //       } else {
      //         // document.getElementById("eight_k").innerHTML = `<p class="abc_goldcoin"> <span> ${Number(bet3_1[t])} </span> </p>`;
      //         if (document.getElementById("eight_k")) {
      //           // document.getElementById("eight_k").appendChild(<div className="abc_goldcoin " style={{ position: "relative" }}><BetPlacedChip betAmount={bet3_1[t]} chipString={this.props.abt_chipValues} gameId={24} /></div>)
      //           const root = ReactDOM.createRoot(document.getElementById("eight_k"));
      //           root.render(<div className="abc_goldcoin " style={{ position: "relative" }}><BetPlacedChip betAmount={bet3_1[t]} chipString={this.props.abt_chipValues} gameId={24} /></div>);
      //         }
      //       }
      //     }
      //   } else {
      //     this.setState({ infoText: this.props.language.MaxBetLmt });
      //   }

      // }


      let bet5 = this.props.gameState.betRequest.betString.split(",")[0];
      const bet5_1 = bet5.split("|");
      for (let e = 0; e < bet5_1.length; e++) {
        // let Changebetslblamt=this.changeAmtlabl( Number(bet5_1[e]))
        bet5_1[e] = Number(bet5_1[e]);
        // bet5_1[e] =Changebetslblamt;

        if (Number(bet5_1[e]) <= this.innerLimits[0][1]) {
          this.abBet[e] = Number(bet5_1[e]);
          if (Number(bet5_1[e]) > 0) {
            if (e == 0) {
              // document.getElementById("andar").innerHTML = `<p class="abc_goldcoin"> <span> ${Number(bet5_1[e])} </span> </p>`;

              if (document.getElementById("andar")) {
                // document.getElementById("andar").appendChild(<div className="abc_goldcoin " style={{ position: "relative" }}><BetPlacedChip betAmount={bet5_1[e]} chipString={this.props.abt_chipValues} gameId={24} /></div>)
                const root = ReactDOM.createRoot(document.getElementById("andar"));
                root.render(<div className="abc_goldcoin " style={{ position: "relative" }}><BetPlacedChip betAmount={bet5_1[e]} chipString={this.props.abt_chipValues} gameId={24} /></div>);
              }

            } else {
              // document.getElementById("bahar").innerHTML = `<p class="abc_goldcoin"> <span> ${Number(bet5_1[e])} </span> </p>`;
              if (document.getElementById("bahar")) {
                // document.getElementById("bahar").appendChild(<div className="abc_goldcoin " style={{ position: "relative" }}><BetPlacedChip betAmount={bet5_1[e]} chipString={this.props.abt_chipValues} gameId={24} /></div>)

                const root = ReactDOM.createRoot(document.getElementById("bahar"));
                root.render(<div className="abc_goldcoin " style={{ position: "relative" }}><BetPlacedChip betAmount={bet5_1[e]} chipString={this.props.abt_chipValues} gameId={24} /></div>);
              }
            }
          }
        } else {
          this.setState({ infoText: this.props.language.MaxBetLmt });
        }
      }
      // this.setState({
      //   totalBetAmount: this.props.gameState.betRequest.betAmount,
      //   totalabbet: this.props.gameState.betRequest.betAmount,
      //   betAmt: this.props.gameState.betRequest.betAmount
      // })


      if (this.props.gameState.response && this.props.gameState.response.winData) {
        this.ChipsDealerPlayer.glowWinImg(this.props.gameState.response.winData);
      }

      // this.ab_timeout2 = setTimeout(() => {
      if (document.getElementById("timeSpan")) {
        if (document.getElementById("timeSpan").innerHTML <= 5 || document.getElementById("timeSpan").innerHTML > 58 || this.props.AndarBaharTimeSend < 6000) {
          this.setState({
            enableKeyboard: false,
          });
        } else {
          if (!this.resultShown) {
            this.setState({
              enableKeyboard: true,
            });
          }
        }
      }
      // }, 1000)

    } else if (this.props.gameState.handId == this.props.gameState.oldHandId && this.props.gameState.handId != undefined) {
      this.setState({
        betButtonText: this.props.language.BetOK,
        betButtonValue: 1,
        totalBetAmount: this.props.gameState.betRequest.betAmount,
        totalabbet: 0,
        infoText: this.props.language.BetAccepted + Number(this.props.gameState.betRequest.betAmount.toFixed(2)),
        enableKeyboard: false,
        isBetSent: true,
      })

      document.getElementById("abc_cover").style.display = "block";
      if (document.getElementById("betBtn")) {
        document.getElementById("betBtn").classList.add("ab_disBtn");
      }
      // let bet1 = this.props.gameState.betRequest.betString.split(",")[0];
      // const bet1_1 = bet1.split("|");
      // for (let j = 0; j < bet1_1.length; j++) {
      //   // let updatebetsocard=this.changeAmtlabl(Number(bet1_1[j]))
      //   this.cardBet[j] = Number(bet1_1[j]);
      //   // this.cardBet[j] = updatebetsocard
      //   if (Number(bet1_1[j] > 0)) {
      //     // document.getElementById("fID_" + j).innerHTML = `<p class="abc_goldcoin"> <span> ${Number(bet1_1[j])} </span> </p>`;


      //     const container = document.getElementById("fID_" + j);
      //     if (container) {
      //       const root = ReactDOM.createRoot(container);
      //       root.render(<div className="abc_goldcoin " style={{ position: "relative" }}><BetPlacedChip betAmount={bet1_1[j]} chipString={this.props.abt_chipValues} gameId={24} /></div>);
      //     }


      //     if (document.getElementById("card_" + j))
      //       document.getElementById("card_" + j).style.transform = "scale(0.9)";
      //   }
      // }

      // let bet2 = this.props.gameState.betRequest.betString.split(",")[1];
      // const bet2_1 = bet2.split("|");
      // for (let y = 0; y < bet2_1.length; y++) {
      //   // let updatebetsocrd=this.changeAmtlabl(Number(bet2_1[y]))
      //   this.suitBet[y] = Number(bet2_1[y]);
      //   // this.suitBet[y] = updatebetsocrd;
      //   if (Number(bet2_1[y]) > 0) {
      //     switch (y) {
      //       case 0:
      //         // document.getElementById("spade").innerHTML = `<p class="abc_goldcoin"> <span> ${Number(bet2_1[y])} </span> </p>`;
      //         if (document.getElementById("spade")) {
      //           const root = ReactDOM.createRoot(document.getElementById("spade"));
      //           root.render(<div className="abc_goldcoin " style={{ position: "relative" }}><BetPlacedChip betAmount={bet2_1[y]} chipString={this.props.abt_chipValues} gameId={24} /></div>);
      //         }
      //         break;
      //       case 1:
      //         // document.getElementById("club").innerHTML = `<p class="abc_goldcoin"> <span> ${Number(bet2_1[y])} </span> </p>`;
      //         if (document.getElementById("club")) {
      //           const root = ReactDOM.createRoot(document.getElementById("club"));
      //           root.render(<div className="abc_goldcoin " style={{ position: "relative" }}><BetPlacedChip betAmount={bet2_1[y]} chipString={this.props.abt_chipValues} gameId={24} /></div>);
      //         }
      //         break;
      //       case 2:
      //         // document.getElementById("dimond").innerHTML = `<p class="abc_goldcoin"> <span> ${Number(bet2_1[y])} </span> </p>`;
      //         if (document.getElementById("dimond")) {
      //           const root = ReactDOM.createRoot(document.getElementById("dimond"));
      //           root.render(<div className="abc_goldcoin " style={{ position: "relative" }}><BetPlacedChip betAmount={bet2_1[y]} chipString={this.props.abt_chipValues} gameId={24} /></div>);
      //         }
      //         break;
      //       case 3:
      //         // document.getElementById("heart").innerHTML = `<p class="abc_goldcoin"> <span> ${Number(bet2_1[y])} </span> </p>`;
      //         if (document.getElementById("heart")) {
      //           const root = ReactDOM.createRoot(document.getElementById("heart"));
      //           root.render(<div className="abc_goldcoin " style={{ position: "relative" }}><BetPlacedChip betAmount={bet2_1[y]} chipString={this.props.abt_chipValues} gameId={24} /></div>);
      //         }
      //         break;
      //     }
      //   }
      // }

      // let bet3 = this.props.gameState.betRequest.betString.split(",")[2];
      // const bet3_1 = bet3.split("|");
      // for (let t = 0; t < bet3_1.length; t++) {
      //   // let updatebts=this.changeAmtlabl(Number(bet3_1[t]))
      //   this.numBet[t] = Number(bet3_1[t])
      //   if (Number(bet3_1[t]) > 0) {
      //     if (t == 0) {
      //       // document.getElementById("one_six").innerHTML = `<p class="abc_goldcoin"> <span> ${Number(bet3_1[t])} </span> </p>`;
      //       if (document.getElementById("one_six")) {
      //         const root = ReactDOM.createRoot(document.getElementById("one_six"));
      //         root.render(<div className="abc_goldcoin " style={{ position: "relative" }}><BetPlacedChip betAmount={bet3_1[t]} chipString={this.props.abt_chipValues} gameId={24} /></div>);
      //       }
      //     } else {
      //       // document.getElementById("eight_k").innerHTML = `<p class="abc_goldcoin"> <span> ${Number(bet3_1[t])} </span> </p>`;
      //       if (document.getElementById("eight_k")) {
      //         const root = ReactDOM.createRoot(document.getElementById("eight_k"));
      //         root.render(<div className="abc_goldcoin " style={{ position: "relative" }}><BetPlacedChip betAmount={bet3_1[t]} chipString={this.props.abt_chipValues} gameId={24} /></div>);
      //       }
      //     }
      //   }
      // }

      let bet5 = this.props.gameState.betRequest.betString.split(",")[0];
      const bet5_1 = bet5.split("|");
      for (let e = 0; e < bet5_1.length; e++) {
        // let bet5=this.changeAmtlabl(Number(bet5_1[e]))
        this.abBet[e] = Number(bet5_1[e]);
        // this.abBet[e] = bet5;
        if (Number(bet5_1[e]) > 0) {
          if (e == 0) {
            // document.getElementById("andar").innerHTML = `<p class="abc_goldcoin"> <span> ${Number(bet5_1[e])} </span> </p>`;

            if (document.getElementById("andar")) {
              // document.getElementById("andar").appendChild(<div className="abc_goldcoin " style={{ position: "relative" }}><BetPlacedChip betAmount={bet5_1[e]} chipString={this.props.abt_chipValues} gameId={24} /></div>)
              const root = ReactDOM.createRoot(document.getElementById("andar"));
              root.render(<div className="abc_goldcoin " style={{ position: "relative" }}><BetPlacedChip betAmount={bet5_1[e]} chipString={this.props.abt_chipValues} gameId={24} /></div>);
            }
          } else {
            // document.getElementById("bahar").innerHTML = `<p class="abc_goldcoin"> <span> ${Number(bet5_1[e])} </span> </p>`;

            if (document.getElementById("bahar")) {
              // document.getElementById("bahar").appendChild(<div className="abc_goldcoin " style={{ position: "relative" }}><BetPlacedChip betAmount={bet5_1[e]} chipString={this.props.abt_chipValues} gameId={24} /></div>)
              const root = ReactDOM.createRoot(document.getElementById("bahar"));
              root.render(<div className="abc_goldcoin " style={{ position: "relative" }}><BetPlacedChip betAmount={bet5_1[e]} chipString={this.props.abt_chipValues} gameId={24} /></div>);
            }
          }
        }
      }

    } else {
      // this.ab_timeout10 = setTimeout(() => {
      if (document.getElementById("timeSpan")) {
        if (document.getElementById("timeSpan").innerHTML <= 5 || document.getElementById("timeSpan").innerHTML > 58 || this.props.AndarBaharTimeSend < 6000) {
          this.setState({
            enableKeyboard: false,
            disableDealBtn: true,
          });
          document.getElementById("betBtn").classList.add("ab_disBtn");
        } else {
          this.setState({
            disableDealBtn: false,
            enableKeyboard: true,
          })
        }
      }
      // }, 500);

      this.setState({
        betButtonText: this.props.language.Prev,
        betButtonValue: 0,
        // disableDealBtn: false,
        // enableKeyboard: true,
      })
      if (this.props.gameState.betRequest && this.props.gameState.betRequest.betAmount > 0) {
        if (document.getElementById("betBtn") && document.getElementById("betBtn").classList.contains("ab_disBtn")) {
          document.getElementById("betBtn").classList.remove("ab_disBtn");
          document.getElementById("betBtn").style.zIndex = 110;
        }
      }

      this.ab_timeout6 = setTimeout(() => {
        if (!this.resultShown) {
          this.setState({ enableKeyboard: true });
        }
      }, 1000);

      if (document.getElementById("abc_cover")) {
        document.getElementById("abc_cover").style.display = "none";
      }
    }

    this.ab_timeout7 = setTimeout(() => {
      document.addEventListener("keyup", this.fc_handleKeyboardEvent);
      // document.addEventListener("keydown", this.fc_bets_handleKeyboardEvent);
    }, 1000);

    // if (!this.resultShown) {
    //   this.setState({ enableKeyboard: true });
    // }
    // console.log(this.props.minBetAmt, this.props.maxBetAmt);

    if (this.props.gameState.handId) {
      this.handId = this.props.gameState.handId;
    }
    const { childRefAB } = this.props;
    childRefAB(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.balance !== this.props.balance) {
      this.setState({ totalabbet: 0 });
    }
  }



  showPreviousBet() {

    if (this.props.gameState.betRequest != undefined) {
      if (this.props.maxBetAmt && this.props.gameState.betRequest.betAmount > this.props.maxBetAmt) {
        this.clearcardspreviuosglows();

        this.setState({ infoText: this.props.language.MinBetAmt + " " + this.props.minBetAmt + " " + this.props.language.MaxBetAmt + " " + this.props.maxBetAmt, startBlink: false });
      } else if (this.props.gameState.betRequest.betAmount <= this.props.balance) {

        // let bet1 = this.props.gameState.betRequest.betString.split(",")[0];
        // const bet1_1 = bet1.split("|");
        // for (let j = 0; j < bet1_1.length; j++) {
        //   // let bet1=this.changeAmtlabl(Number(bet1_1[j]))
        //   bet1_1[j] = Number(bet1_1[j])
        //   // bet1_1[j] =bet1
        //   if (Number(bet1_1[j]) <= this.innerLimits[0][1]) {
        //     this.cardBet[j] = Number(bet1_1[j]);
        //     if (Number(bet1_1[j]) > 0) {
        //       this.setState({ betCard: j })
        //       this.cardBetAmt = Number(bet1_1[j]);
        //       // document.getElementById("fID_" + j).innerHTML = `<p class="abc_goldcoin"> <span> ${this.changeAmtlabl(bet1_1[j])} </span> </p>`;


        //       const container = document.getElementById("fID_" + j);
        //       if (container) {
        //         const root = ReactDOM.createRoot(container);
        //         root.render(<div className="abc_goldcoin " style={{ position: "relative" }}><BetPlacedChip betAmount={bet1_1[j]} chipString={this.props.abt_chipValues} gameId={24} /></div>);
        //       }



        //       if (document.getElementById("card_" + j))
        //         document.getElementById("card_" + j).style.transform = "scale(0.9)";
        //     }
        //   } else {
        //     this.setState({ infoText: this.props.language.MaxBetLmt });
        //   }
        // }

        // let bet2 = this.props.gameState.betRequest.betString.split(",")[1];
        // const bet2_1 = bet2.split("|");
        // for (let y = 0; y < bet2_1.length; y++) {
        //   // let bet2=this.changeAmtlabl(Number(bet2_1[y]))

        //   // bet2_1[y] =bet2
        //   bet2_1[y] = Number(bet2_1[y]);
        //   if (Number(bet2_1[y]) <= this.innerLimits[1][1]) {
        //     this.suitBet[y] = Number(bet2_1[y]);
        //     if (Number(bet2_1[y]) > 0) {
        //       switch (y) {
        //         case 0:
        //           // document.getElementById("spade").innerHTML = `<p class="abc_goldcoin"> <span> ${this.changeAmtlabl(bet2_1[y])} </span> </p>`;

        //           if (document.getElementById("spade")) {
        //             const root = ReactDOM.createRoot(document.getElementById("spade"));
        //             root.render(<div className="abc_goldcoin " style={{ position: "relative" }}><BetPlacedChip betAmount={bet2_1[y]} chipString={this.props.abt_chipValues} gameId={24} /></div>);
        //           }
        //           break;
        //         case 1:
        //           // document.getElementById("club").innerHTML = `<p class="abc_goldcoin"> <span> ${this.changeAmtlabl(bet2_1[y])} </span> </p>`;

        //           if (document.getElementById("club")) {
        //             const root = ReactDOM.createRoot(document.getElementById("club"));
        //             root.render(<div className="abc_goldcoin " style={{ position: "relative" }}><BetPlacedChip betAmount={bet2_1[y]} chipString={this.props.abt_chipValues} gameId={24} /></div>);
        //           }
        //           break;
        //         case 2:
        //           // document.getElementById("dimond").innerHTML = `<p class="abc_goldcoin"> <span> ${this.changeAmtlabl(bet2_1[y])} </span> </p>`;
        //           if (document.getElementById("dimond")) {
        //             const root = ReactDOM.createRoot(document.getElementById("dimond"));
        //             root.render(<div className="abc_goldcoin " style={{ position: "relative" }}><BetPlacedChip betAmount={bet2_1[y]} chipString={this.props.abt_chipValues} gameId={24} /></div>);
        //           }
        //           break;
        //         case 3:
        //           // document.getElementById("heart").innerHTML = `<p class="abc_goldcoin"> <span> ${this.changeAmtlabl(bet2_1[y])} </span> </p>`;
        //           if (document.getElementById("heart")) {
        //             const root = ReactDOM.createRoot(document.getElementById("heart"));
        //             root.render(<div className="abc_goldcoin " style={{ position: "relative" }}><BetPlacedChip betAmount={bet2_1[y]} chipString={this.props.abt_chipValues} gameId={24} /></div>);
        //           }
        //           break;
        //       }
        //     }
        //   } else {
        //     this.setState({ infoText: this.props.language.MaxBetLmt });
        //   }
        // }

        // let bet3 = this.props.gameState.betRequest.betString.split(",")[2];
        // const bet3_1 = bet3.split("|");
        // for (let t = 0; t < bet3_1.length; t++) {
        //   // let bet3=this.changeAmtlabl(Number(bet3_1[t]))
        //   // bet3_1[t] = bet3;
        //   bet3_1[t] = Number(bet3_1[t]);
        //   if (Number(bet3_1[t]) <= this.innerLimits[2][1]) {
        //     this.numBet[t] = Number(bet3_1[t]);
        //     if (Number(bet3_1[t]) > 0) {
        //       if (t == 0) {
        //         // document.getElementById("one_six").innerHTML = `<p class="abc_goldcoin"> <span> ${this.changeAmtlabl(bet3_1[t])} </span> </p>`;

        //         if (document.getElementById("one_six")) {
        //           const root = ReactDOM.createRoot(document.getElementById("one_six"));
        //           root.render(<div className="abc_goldcoin " style={{ position: "relative" }}><BetPlacedChip betAmount={bet3_1[t]} chipString={this.props.abt_chipValues} gameId={24} /></div>);
        //         }
        //       } else {
        //         // document.getElementById("eight_k").innerHTML = `<p class="abc_goldcoin"> <span> ${this.changeAmtlabl(bet3_1[t])} </span> </p>`;
        //         if (document.getElementById("eight_k")) {
        //           const root = ReactDOM.createRoot(document.getElementById("eight_k"));
        //           root.render(<div className="abc_goldcoin " style={{ position: "relative" }}><BetPlacedChip betAmount={bet3_1[t]} chipString={this.props.abt_chipValues} gameId={24} /></div>);
        //         }

        //       }
        //     }
        //   } else {
        //     this.setState({ infoText: this.props.language.MaxBetLmt });
        //   }

        // }


        let bet5 = this.props.gameState.betRequest.betString.split(",")[0];
        const bet5_1 = bet5.split("|");
        for (let e = 0; e < bet5_1.length; e++) {
          // let bet5=this.changeAmtlabl(Number(bet5_1[e]))

          // bet5_1[e] = bet5;

          bet5_1[e] = Number(bet5_1[e]);

          if (Number(bet5_1[e]) <= this.innerLimits[0][1]) {
            this.abBet[e] = Number(bet5_1[e]);
            if (Number(bet5_1[e]) > 0) {
              if (e == 0) {
                // document.getElementById("andar").innerHTML = `<p class="abc_goldcoin"> <span> ${this.changeAmtlabl(bet5_1[e])} </span> </p>`;
                if (document.getElementById("andar")) {
                  // document.getElementById("andar").appendChild(<div className="abc_goldcoin " style={{ position: "relative" }}><BetPlacedChip betAmount={bet5_1[e]} chipString={this.props.abt_chipValues} gameId={24} /></div>)

                  const root = ReactDOM.createRoot(document.getElementById("andar"));
                  root.render(<div className="abc_goldcoin " style={{ position: "relative" }}><BetPlacedChip betAmount={bet5_1[e]} chipString={this.props.abt_chipValues} gameId={24} /></div>);
                }
              } else {
                // document.getElementById("bahar").innerHTML = `<p class="abc_goldcoin"> <span> ${this.changeAmtlabl(bet5_1[e])} </span> </p>`;
                if (document.getElementById("bahar")) {
                  // document.getElementById("bahar").appendChild(<div className="abc_goldcoin " style={{ position: "relative" }}><BetPlacedChip betAmount={bet5_1[e]} chipString={this.props.abt_chipValues} gameId={24} /></div>)

                  const root = ReactDOM.createRoot(document.getElementById("bahar"));
                  root.render(<div className="abc_goldcoin " style={{ position: "relative" }}><BetPlacedChip betAmount={bet5_1[e]} chipString={this.props.abt_chipValues} gameId={24} /></div>);
                }
              }
            }
          } else {
            this.setState({ infoText: this.props.language.MaxBetLmt });
          }
        }
        this.setState({
          totalBetAmount: this.props.gameState.betRequest.betAmount,
          totalabbet: this.props.gameState.betRequest.betAmount,
          betAmt: this.props.gameState.betRequest.betAmount
        })
        if (this.props.gameState.handId) {
          this.handId = this.props.gameState.handId;
        }
      } else {
        this.setState({ infoText: this.props.language.BetAmtMaxBal });
      }
    }
  }

  disableBtn(btnId) {
    let disBtn = document.getElementById(btnId);
    if (disBtn) {
      disBtn.classList.add("ab_disBtn");
      disBtn.disabled = true;
    }
  }

  enableBtn(btnId) {
    let enableBtn = document.getElementById(btnId);
    if (enableBtn) {
      enableBtn.classList.remove("ab_disBtn");
      enableBtn.disabled = false;
    }
  }

  componentWillUnmount() {
    clearInterval(this.spriteInterval)
    clearTimeout(this.ab_timeout1)
    clearTimeout(this.ab_timeout2)
    clearTimeout(this.ab_timeout3)
    clearTimeout(this.ab_timeout4)
    clearTimeout(this.ab_timeout5)
    clearTimeout(this.ab_timeout6)
    clearTimeout(this.ab_timeout7)
    clearTimeout(this.ab_timeout8)
    clearTimeout(this.ab_timeout9)
    clearTimeout(this.ab_timeout10)
    clearTimeout(this.ab_timeout11)
    clearTimeout(this.ab_timeout12)
    clearTimeout(this.ab_timeout13)
    this.stopVideo()
    // document.removeEventListener("keydown", this.fc_bets_handleKeyboardEvent);
    document.removeEventListener("keyup", this.fc_handleKeyboardEvent);
  }

  andarBaharTimer_GetTime() {
    if (this.props.ab_timeSend) {
      if (this.TopLable) {
        this.TopLable.sendTimer(this.props.ab_timeSend);
      }
      // console.log(this.props.ab_timeSend, this.state.isCardsDealing)
      if (this.props.ab_timeSend > 5 && !this.state.isCardsDealing && !this.state.isBetSent) {
        this.setState({ enableKeyboard: true, disableDealBtn: false })
      }
    }
  }

  fc_bets_handleKeyboardEvent = (evt) => {
    if (this.state.betButtonValue != 2 && this.state.isGameActive && this.state.enableKeyboard) {
      if (document.getElementById("abc_cover") && document.getElementById("abc_cover").style.display != "block") {

        if (evt.keyCode >= 48 && evt.keyCode <= 57 && evt.keyCode != 49) {
          if (evt.keyCode == 48) {
            this.selectedCard(9);
          } else {
            this.selectedCard(evt.key - 1);
          }
          // this.betoncard = new Audio(betoncard)
          // this.betoncard.play();
          this.playPokerBetSound(this.betoncard);
        }
        if (evt.keyCode >= 96 && evt.keyCode <= 105 && evt.keyCode != 97) {
          if (evt.keyCode == 96) {
            this.selectedCard(9);

          } else {
            this.selectedCard(evt.key - 1);
          }
          // this.betoncard = new Audio(betoncard)
          // this.betoncard.play();
          this.playPokerBetSound(this.betoncard);
        }
        if (evt.keyCode == 74) {
          this.selectedCard(10);
          // this.betoncard = new Audio(betoncard)
          // this.betoncard.play();
          this.playPokerBetSound(this.betoncard);
        }
        if (evt.keyCode == 81) {
          this.selectedCard(11);
          // this.betoncard = new Audio(betoncard)
          // this.betoncard.play();
          this.playPokerBetSound(this.betoncard);
        }
        if (evt.keyCode == 75) {
          this.selectedCard(12);
          // this.betoncard = new Audio(betoncard)
          // this.betoncard.play();
          this.playPokerBetSound(this.betoncard);
        }
        if (evt.keyCode == 65) {
          this.selectedCard(0)
          // this.betoncard = new Audio(betoncard)
          // this.betoncard.play();
          this.playPokerBetSound(this.betoncard);
        }
      }
    }
  }

  fc_handleKeyboardEvent = (evt) => {
    if (this.state.isGameActive) {
      switch (evt.code) {
        case "Enter":
        case "NumpadEnter":
          if (this.state.betButtonValue != 2 && this.state.disableDealBtn == false && this.state.enableKeyboard) {
            this.bet_fn();
            if (this.betSound) {
              this.betSound.play();
            }
          }
          break;
        case "Space":

          if (this.takeSound) {
            this.takeSound.play();
            if (this.state.betButtonValue == 2 && this.state.disableDealBtn == false && this.state.enableKeyboard) {
              this.bet_fn();
            }
          }
          //   break;
          // case "Escape":
          //   if (this.betSound) {
          //     this.betSound.play();
          //   }
          //   this.gameCloseHandler();
          break;
        case "KeyC":
          if (this.state.betButtonValue == 1 && this.state.disableDealBtn == false && this.state.enableKeyboard) {
            this.clear_fn();
            if (this.clearSound) {
              this.clearSound.play();
            }
          }
          break;
        case "KeyD":
          if (this.betSound) {
            this.betSound.play();
            if (this.state.betButtonValue == 1 && this.state.disableDealBtn == false && this.state.totalBetAmount > 0 && this.state.enableKeyboard) {
              this.doubleAmount();
            }
          }
          break
        case "default":
          break;
      }
    }
  }

  disableBtns() {

    this.setState({ enableKeyboard: false, startBlink: false });
    this.disableBtn("clearBtn");
    this.disableBtn("doubleBtn");
    this.disableBtn("betBtn");
    this.ChipsDealerPlayer.disableBetOptions();
    if (document.getElementById('abc_cover')) {
      document.getElementById('abc_cover').style.zIndex = 10000;
      // document.getElementById('abc_cover').style.zIndex = 190;
      document.getElementById('abc_cover').style.display = 'block';
    }

    if (document.getElementById("res_andar_Card")) {
      document.getElementById("res_andar_Card").style.display = "none";
    }

    if (document.getElementById("res_bahar_Card")) {
      document.getElementById("res_bahar_Card").style.display = "none";
    }
    // document.getElementById("resJokerCard").style.display = "none";

    const andhar_list = document.getElementById("res_andar_Card");
    if (andhar_list.hasChildNodes()) {
      while (andhar_list.hasChildNodes()) {
        andhar_list.removeChild(andhar_list.firstChild);
      }
    }
    const bahar_list = document.getElementById("res_bahar_Card");
    if (bahar_list.hasChildNodes()) {
      while (bahar_list.hasChildNodes()) {
        bahar_list.removeChild(bahar_list.firstChild);
      }
    }
  }

  check_spec() {
    if (this.state.totalBetAmount < this.props.minBetAmt && !this.isSpectSent) {
      this.isSpectSent = true;
      this.props.spectatorCount(0, this.handId);
    } else if (this.state.takeAmount != 0 && this.isSpectSent == false) {
      this.isSpectSent = true;
      this.props.spectatorCount(0, this.handId);
    }
  }
  auto_bet() {
    // alert(this.state.totalBetAmount)
    if (!this.state.isBetSent) {
      if (this.state.totalBetAmount > 0 && this.state.totalBetAmount >= this.props.minBetAmt && this.state.totalBetAmount <= this.props.maxBetAmt) {
        this.bet_fn();
      } else {
        this.clear_fn()
      }
    }
  }
  getPlayerInfo() {
    const body2 = {
      CN: "GET_PLAYER_INFO",
      object: {
        gameId: this.props.gameId,
        playerId: Number(this.props.playerId),
      },
      sessionId: sessionStorage.getItem('sessionId'),
    };
    this.props.network.sendof(body2);
    this.body2 = {};
  }
  declare_Result() {
    this.isSpectSent = false;
    if (this.state.isGameActive) {
      if (this.props.gameState.handId) {
        this.handId = this.props.gameState.handId;
      }

      // let winData = [0,0,0,0,1,0]
      if (this.props.andarBaharTimerResult.winData) {
        this.ChipsDealerPlayer.glowWinImg(this.props.andarBaharTimerResult.winData);
      }

      if (this.props.andarBaharTimerResult.winAmount > 0) {
        document.getElementById('winPopandb').style.display = 'block';
        // this.takeAmount();
        this.getPlayerInfo();

        if (this.winSound) {
          this.winSound.play();
        }
        this.setState({ takeAmount: this.props.andarBaharTimerResult.winAmount, winGlowImg: true })

        this.ab_timeout3 = setTimeout(() => {
          this.setState({
            // startBlink: true,
            // infoText: this.props.language.ClickTake,

            isBetSent: false,
            disableDealBtn: false,
          })

          this.resultShown = false;
          this.enableBtn("betBtn");
          //15
          this.enableBtn("doubleBtn");

          document.getElementById("betBtn").style.zIndex = 180;
          if (document.getElementById('abc_cover')) {
            document.getElementById('abc_cover').style.zIndex = 150;
            // document.getElementById('abc_cover').style.display = 'none';
          }

          this.updateHistory();
          // this.ab_timeout9 = setTimeout(() => {
          //   this.setState({ enableKeyboard: true })
          // }, 500)

          this.ab_timeout8 = setTimeout(() => {
            document.getElementById('winPopandb').style.display = 'none';
            this.setState({takeAmount: 0})

            // this.setState({
            //   infoText: this.props.language.AmusementOnly +
            //     this.props.language.MinBetAmt + " " + this.props.minBetAmt + " " + this.props.language.MaxBetAmt + " " + this.props.maxBetAmt
            // });
          }, 1000)

        }, 500);

      } else {
        this.getPlayerInfo();

        this.ab_timeout5 = setTimeout(() => {
          // this.setState({ disableDealBtn: false })

          if (this.state.takeAmount == 0) {
            this.setState({ isBetSent: false })
            if (document.getElementById("abc_cover")) {
              // document.getElementById("abc_cover").style.display = "none";
            }
            this.clear_fn();
            if (this.props.gameState && this.props.gameState.betRequest && this.props.gameState.betRequest.betString) {
              this.ab_timeout12 = setTimeout(() => {
                // this.enableBtn("betBtn");
                //14
                // this.enableBtn("doubleBtn");
                // this.setState({ enableKeyboard: true });
              }, 500);
            }
          } else {
            // this.enableBtn("betBtn");
            //13
            // this.enableBtn("doubleBtn");
            document.getElementById("abc_cover").style.zIndex = 150;
            this.ab_timeout13 = setTimeout(() => {
              // this.setState({ startBlink: true, enableKeyboard: true })
              document.getElementById("betBtn").style.zIndex = 180;
            }, 500);
          }
          this.updateHistory();
          this.resultShown = false;
        }, 800)
      }
    }
    // if (document.getElementById('abc_cover')) {
    //   document.getElementById('abc_cover').style.display = 'none';
    // }
    this.props.gamstateHandle();
  }


  clear_fn() {

    this.cardBetAmt = 0;
    this.cardBet = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.suitBet = [0, 0, 0, 0];
    this.numBet = [0, 0];
    this.abBet = [0, 0];

    this.setState({
      betAmt: 0,
      disable: true,
      betCard: null,
      btnActive: false,
      disableClearBtn: true,
      infoText: this.props.language.AmusementOnly,
      totalBetAmount: 0,
      totalabbet: 0,
      betButtonText: this.props.language.Prev,
      betButtonValue: 0,
      startBlink: false,
    });
    this.disableBtn("doubleBtn");
    this.disableBtn("clearBtn");
    if (this.props.gameState.betRequest && this.props.gameState.betRequest.betAmount > 0) {
      let preBet = (this.props.gameState.betRequest.betString).split(","[0]);

    } else {
      this.setState({ disableBetBtn: true });
      this.disableBtn("betBtn")
      //1
      this.disableBtn("doubleBtn");
    }

    for (let m = 0; m < 13; m++) {
      if (document.getElementById("fID_" + m)) {
        // document.getElementById("fID_" + m).innerHTML = `<p class="abc_goldcoin"/>`;

        const container = document.getElementById("fID_" + m);
        if (container) {
          const root = ReactDOM.createRoot(container);
          root.render(<div className="abc_goldcoin " style={{ position: "relative" }}></div>);
        }
      }
      if (document.getElementById("card_" + m))
        document.getElementById("card_" + m).style.transform = "scale(1)";

    }
    this.ab_betString = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

    // if (document.getElementById('heart')) {
    //   document.getElementById('heart').innerHTML = `<p class="abc_goldcoin"> </p>`;
    // }
    // if (document.getElementById('club')) {
    //   document.getElementById('club').innerHTML = `<p class="abc_goldcoin"> </p>`;
    // }
    // if (document.getElementById('spade')) {
    //   document.getElementById('spade').innerHTML = `<p class="abc_goldcoin"> </p>`;
    // }
    // if (document.getElementById('dimond')) {
    //   document.getElementById('dimond').innerHTML = `<p class="abc_goldcoin"> </p>`;
    // }
    // if (document.getElementById('one_six')) {
    //   document.getElementById('one_six').innerHTML = `<p class="abc_goldcoin"> </p>`;
    // }
    // if (document.getElementById('eight_k')) {
    //   document.getElementById('eight_k').innerHTML = `<p class="abc_goldcoin"> </p>`;
    // }
    // if (document.getElementById('andar')) {
    //   document.getElementById('andar').innerHTML = `<p class="abc_goldcoin"> </p>`;
    // }
    // if (document.getElementById('bahar')) {
    //   document.getElementById('bahar').innerHTML = `<p class="abc_goldcoin"> </p>`;
    // }
    // if (document.getElementById("one_six")) {
    //   document.getElementById("one_six").innerHTML = `<p class="abc_goldcoin"> </p>`;
    // }
    // if (document.getElementById("eight_k")) {
    //   document.getElementById("eight_k").innerHTML = `<p class="abc_goldcoin"> </p>`;
    // }


    if (document.getElementById("heart")) {
      const root = ReactDOM.createRoot(document.getElementById("heart"));
      root.render(<div className="abc_goldcoin " style={{ position: "relative" }}></div>);
    }
    if (document.getElementById("club")) {
      const root = ReactDOM.createRoot(document.getElementById("club"));
      root.render(<div className="abc_goldcoin " style={{ position: "relative" }}></div>);
    }
    if (document.getElementById("spade")) {
      const root = ReactDOM.createRoot(document.getElementById("spade"));
      root.render(<div className="abc_goldcoin " style={{ position: "relative" }}></div>);
    }
    if (document.getElementById("dimond")) {
      const root = ReactDOM.createRoot(document.getElementById("dimond"));
      root.render(<div className="abc_goldcoin " style={{ position: "relative" }}></div>);
    }
    if (document.getElementById("one_six")) {
      const root = ReactDOM.createRoot(document.getElementById("one_six"));
      root.render(<div className="abc_goldcoin " style={{ position: "relative" }}></div>);
    }
    if (document.getElementById("eight_k")) {
      const root = ReactDOM.createRoot(document.getElementById("eight_k"));
      root.render(<div className="abc_goldcoin " style={{ position: "relative" }}></div>);
    }
    if (document.getElementById("andar")) {
      const root = ReactDOM.createRoot(document.getElementById("andar"));
      root.render(<div className="abc_goldcoin " style={{ position: "relative" }}></div>);
    }
    if (document.getElementById("bahar")) {
      const root = ReactDOM.createRoot(document.getElementById("bahar"));
      root.render(<div className="abc_goldcoin " style={{ position: "relative" }}></div>);
    }
  }

  setJokerRollCard() {
    this.ab_ch_timeout13 = setTimeout(() => {
      this.ChipsDealerPlayer.setJokerRollCard()
      this.ChipsDealerPlayer.removeWinGlow();
      this.clearcardspreviuosglows()
      this.clear_fn()
    }, 2500)
  }

  bet_fn() {
    // console.log(this.state.isGameActive, !this.state.isCardsDealing, this.props.ab_timeSend, !this.state.isBetSent)
    if (this.state.isGameActive && !this.state.isCardsDealing && this.props.ab_timeSend > 5 && !this.state.isBetSent) {

      if (this.state.betButtonValue == 0) {
        if (this.props.gameState.betRequest && this.props.gameState.betRequest.betAmount > 0) {
          if (this.props.gameState.betRequest.betAmount <= this.props.balance) {
            if (this.props.gameState.betRequest.betAmount <= this.props.maxBetAmt) {

              this.setState({
                infoText: this.props.language.AmusementOnly,
                //  isBetSent: true 
              });

              document.getElementById("res_andar_Card").style.display = "none";
              document.getElementById("res_bahar_Card").style.display = "none";
              // document.getElementById("resJokerCard").style.display = "none";

              const andhar_list = document.getElementById("res_andar_Card");

              this.ChipsDealerPlayer.removeWinGlow();


              while (andhar_list.hasChildNodes()) {
                andhar_list.removeChild(andhar_list.firstChild);
              }

              const bahar_list = document.getElementById("res_bahar_Card");

              while (bahar_list.hasChildNodes()) {
                bahar_list.removeChild(bahar_list.firstChild);
              }

              this.showPreviousBet();

              this.setState({ betButtonValue: 1, betButtonText: this.props.language.BetOK, startBlink: true });
              this.enableBtn("clearBtn");
              this.enableBtn("doubleBtn");
            } else {
              this.setState({ infoText: this.props.language.PreBetLmt });
            }
          } else {
            this.setState({ infoText: this.props.language.BetAmtMaxBal });
          }
        }
      } else if (this.state.betButtonValue == 1) {

        if (this.state.totalBetAmount > 0 && this.state.totalBetAmount >= this.props.minBetAmt) {
          let cardBetValid = false;
          let suitBetValid = false;
          let atokBetValid = false;
          // let num7BetValid = false;
          let abBetValid = false;

          for (let m = 0; m < this.cardBet.length; m++) {
            if (this.cardBet[m] > 0) {
              if (this.cardBet[m] >= this.innerLimits[0][0]) {
                cardBetValid = true;
              } else {
                cardBetValid = false;
                break;
              }
              // break;
            } else {
              cardBetValid = true;
            }
          }

          for (let n = 0; n < this.suitBet.length; n++) {
            if (this.suitBet[n] > 0) {
              if (this.suitBet[n] >= this.innerLimits[1][0]) {
                suitBetValid = true;
              } else {
                suitBetValid = false;
                break;
              }
            } else {
              suitBetValid = true;
            }
          }


          for (let q = 0; q < this.numBet.length; q++) {
            if (this.numBet[q] > 0) {
              if (this.numBet[q] >= this.innerLimits[2][0]) {
                atokBetValid = true;
              } else {
                atokBetValid = false;
                break;
              }
            } else {
              atokBetValid = true;
            }
            if (this.abBet[q] > 0) {
              if (this.abBet[q] >= this.innerLimits[0][0]) {
                abBetValid = true;
              } else {
                abBetValid = false;
                break;
              }
            } else {
              abBetValid = true;
            }
          }


          if (cardBetValid && suitBetValid && atokBetValid && abBetValid) {
            this.cardBet = this.cardBet.toString().replace(/,/g, '|');
            this.suitBet = this.suitBet.toString().replace(/,/g, '|');
            this.numBet = this.numBet.toString().replace(/,/g, '|');
            this.abBet = this.abBet.toString().replace(/,/g, '|');

            // this.ab_betString = this.cardBet + "," + this.suitBet + "," + this.numBet + "," + this.abBet;
            this.ab_betString = this.abBet;

            this.setState({ startBlink: false })
            if (document.getElementById("abc_cover")) {
              document.getElementById("abc_cover").style.display = "block";
            }
            this.disableBtn("betBtn");
            //2
            this.disableBtn("doubleBtn");
            this.setState({ disableDealBtn: true, isBetSent: true });
            let ab_bet_body = {
              sessionId: sessionStorage.getItem("sessionId"),
              CN: "ANDAR_BAHAR_CLASSIC_BET",
              handId: Number(this.props.gameState.handId),
              object: {
                betString: this.ab_betString,
                playerId: Number(this.props.playerId),
                gameId: this.props.gameId,
                betAmount: Number(this.state.totalBetAmount).toFixed(2),
              },
            };
            this.props.network.sendof(ab_bet_body);
            this.ChipsDealerPlayer.removeWinGlow();
            // let pinfo_body = {
            //   CN: "GET_PLAYER_INFO",
            //   object: {
            //     playerId: Number(this.props.playerId),
            //     gameId: this.props.gameId,
            //   },
            //   sessionId: sessionStorage.getItem('sessionId'),
            // };
            // this.props.network.sendof(pinfo_body);

            document.getElementById("res_andar_Card").style.display = "none";
            document.getElementById("res_bahar_Card").style.display = "none";
            // document.getElementById("resJokerCard").style.display = "none";
          } else {
            this.setState({ infoText: this.props.language.MinBetLmt })
          }
        } else {
          this.setState({ infoText: this.props.language.MinBetLmt })

        }

      }

      // else if (this.state.betButtonValue == 2) {
      //   this.disableBtn("betBtn");
      //   this.setState({ disableDealBtn: true });
      //   document.getElementById("ab_Cover").style.display = "block";
      //   // const body = {
      //   //   sessionId: sessionStorage.getItem('sessionId'),
      //   //   CN: "TAKE_AMOUNT",
      //   //   object: {
      //   //     gameId: this.props.gameId,
      //   //     playerId: Number(this.props.playerId),
      //   //   },
      //   // };
      //   // this.props.network.sendof(body);
      //   // this.body = {};

      //   this.ChipsDealerPlayer.removeWinGlow();

      //   this.clear_fn();

      //   document.getElementById("betBtn").style.zIndex = 80;
      //   this.setState({ btnActive: false });
      //   document.getElementById("res_andar_Card").style.display = "none";
      //   document.getElementById("res_bahar_Card").style.display = "none";
      //   document.getElementById("resJokerCard").style.display = "none";

      //   const andhar_list = document.getElementById("res_andar_Card");

      //   this.ab_timeout11 = setTimeout(() => {       
      //     this.setState({ 
      //       btnActive: false,
      //       takeAmount: 0,
      //       disableDealBtn: false,
      //       winGlowImg: false,
      //       betAmt: 0,
      //       betCard: null,
      //       infoText: this.props.language.Play_Njoy,
      //       startBlink: false,
      //     })
      //     this.enableBtn("betBtn"); 
      //     document.getElementById("ab_Cover").style.display = "none";
      //   },800)

      //   while (andhar_list.hasChildNodes()) {
      //     andhar_list.removeChild(andhar_list.firstChild);
      //   }

      //   const bahar_list = document.getElementById("res_bahar_Card");

      //   while (bahar_list.hasChildNodes()) {
      //     bahar_list.removeChild(bahar_list.firstChild);
      //   }

      //   if (this.props.isPlayerBanned) {
      //     this.gameCloseHandler("target");
      //     this.props.player_banned();
      //   }

      //   if (this.props.gameUnderMaintanance) {
      //     this.gameCloseHandler("target");
      //     this.props.game_maintanance("Game under maintenance, reach to admin.");
      //   }

      //   if (this.props.isdeviceBlocked) {
      //     this.gameCloseHandler("target");
      //     this.props.device_blocked();
      //   }


      // }
    }
  }






  takeAmount() {
    // this.enableBtn("clearBtn");
    this.disableBtn("betBtn");
    //3
    this.disableBtn("doubleBtn");
    this.setState({ disableDealBtn: true });
    // document.getElementById("ab_Cover").style.display = "none";
    const body = {
      sessionId: sessionStorage.getItem('sessionId'),
      CN: "TAKE_AMOUNT",
      object: {
        gameId: this.props.gameId,
        playerId: Number(this.props.playerId),
      },
    };
    this.props.network.sendof(body);
    this.body = {};

    // this.ChipsDealerPlayer.removeWinGlow();

    this.clear_fn();

    document.getElementById("betBtn").style.zIndex = 80;
    this.setState({ btnActive: false });
    // document.getElementById("res_andar_Card").style.display = "none";
    // document.getElementById("res_bahar_Card").style.display = "none";
    // document.getElementById("resJokerCard").style.display = "none";

    // const andhar_list = document.getElementById("res_andar_Card");

    this.ab_timeout11 = setTimeout(() => {
      this.setState({
        btnActive: false,
        // takeAmount: 0,
        disableDealBtn: false,
        winGlowImg: false,
        betAmt: 0,
        betCard: null,
        infoText: this.props.language.Play_Njoy,
        startBlink: false,
      },
        () => {
          setTimeout(() => {
            this.setState({ takeAmount: 0 });
          }, 4500);
        }
      )
      //  this.enableBtn("betBtn"); 
      // document.getElementById("ab_Cover").style.display = "none";
    }, 1500)

    // while (andhar_list.hasChildNodes()) {
    //   andhar_list.removeChild(andhar_list.firstChild);
    // }

    // const bahar_list = document.getElementById("res_bahar_Card");

    // while (bahar_list.hasChildNodes()) {
    //   bahar_list.removeChild(bahar_list.firstChild);
    // }

    if (this.props.isPlayerBanned) {
      this.gameCloseHandler("target");
      this.props.player_banned();
    }

    if (this.props.gameUnderMaintanance) {
      this.gameCloseHandler("target");
      this.props.game_maintanance("Game under maintenance, reach to admin.");
    }

    if (this.props.isdeviceBlocked) {
      this.gameCloseHandler("target");
      this.props.device_blocked();
    }



  }
  gameClosed() {
    if (document.getElementById('abc_cover')) {
      document.getElementById('abc_cover').style.display = 'none';
    }
    window.clearTimeout(this.ab_timeout1);
    window.clearTimeout(this.ab_timeout2);
    window.clearTimeout(this.ab_timeout3);
    window.clearTimeout(this.ab_timeout4);
    window.clearTimeout(this.ab_timeout5);
    window.clearTimeout(this.ab_timeout6);
    window.clearTimeout(this.ab_timeout7);
    window.clearTimeout(this.ab_timeout8);
    window.clearTimeout(this.ab_timeout9);
    window.clearTimeout(this.ab_timeout10)
    window.clearTimeout(this.ab_timeout11)
    window.clearTimeout(this.ab_timeout12)
    window.clearTimeout(this.ab_timeout13)
    window.clearTimeout(this.ab_ch_timeout13);
    clearInterval(this.spriteInterval);
    this.stopVideo()
    if (this.TopLable) {
      this.TopLable.closeGame();
    }

    this.setState({ isGameActive: false, enableKeyboard: false });

    if (this.winSound.playing) {
      this.winSound.pause();
    }
    this.betSound.pause();
    this.takeSound.pause();

  }
  gameCloseHandler(game) {
    this.close.play();
    window.clearTimeout(this.ab_timeout1);
    window.clearTimeout(this.ab_timeout2);
    window.clearTimeout(this.ab_timeout3);
    window.clearTimeout(this.ab_timeout4);
    window.clearTimeout(this.ab_timeout5);
    window.clearTimeout(this.ab_timeout6);
    window.clearTimeout(this.ab_timeout7);
    window.clearTimeout(this.ab_timeout8);
    window.clearTimeout(this.ab_timeout9);
    window.clearTimeout(this.ab_timeout10)
    window.clearTimeout(this.ab_timeout11)
    window.clearTimeout(this.ab_timeout12)
    window.clearTimeout(this.ab_timeout13)
    window.clearTimeout(this.ab_ch_timeout13);
    clearInterval(this.spriteInterval);
    this.stopVideo()

    if (this.TopLable) {
      this.TopLable.closeGame();
    }

    this.setState({ isGameActive: false, enableKeyboard: false });

    if (this.winSound.playing) {
      this.winSound.pause();
    }
    this.betSound.pause();
    this.takeSound.pause();
    this.props.action(game);
  }

  getChipVal(val) {
    if (this.betSound) {
      this.betSound = new Audio(betSound);
      this.betSound.play();
    }
    this.setState({
      chipVal: Number(val),
    });
  }

  selecteSuit(id) {
    // let totalBetAmt = 0;
    if (this.state.takeAmount || this.state.isBetSent || this.state.isCardsDealing || this.props.ab_timeSend <= 5) {
      return
    }
    // let maxInnerValue = 0;
    if (this.state.chipVal != 0) {
      let totBet = Number(this.state.chipVal + this.state.totalBetAmount);
      if ((this.state.chipVal + this.state.totalBetAmount) <= this.props.balance) {
        if ((this.state.chipVal + this.state.totalBetAmount) <= this.props.maxBetAmt) {
          let suitBetAmt = 0;

          switch (id) {
            case "spade":
              // suitBetAmt=this.changeAmtlabl(Number(this.suitBet[0]) + Number(this.state.chipVal))

              suitBetAmt = Number((Number(this.suitBet[0]) + Number(this.state.chipVal)).toFixed(2));
              this.setState({ maxInnerValue: this.innerLimits[1][1] });
              this.state.maxInnerValue = Number(this.innerLimits[1][1]);
              if (suitBetAmt <= Number(this.innerLimits[1][1]) && totBet <= this.props.maxBetAmt) {
                this.suitBet[0] = suitBetAmt;
              }
              break;
            case "club":
              suitBetAmt = Number((Number(this.suitBet[1]) + Number(this.state.chipVal)).toFixed(2));
              this.setState({ maxInnerValue: this.innerLimits[1][1] });
              this.state.maxInnerValue = Number(this.innerLimits[1][1]);
              if (suitBetAmt <= Number(this.innerLimits[1][1]) && totBet <= this.props.maxBetAmt) {
                this.suitBet[1] = suitBetAmt;
              }
              break;
            case "dimond":
              suitBetAmt = Number((Number(this.suitBet[2]) + Number(this.state.chipVal)).toFixed(2));

              this.setState({ maxInnerValue: Number(this.innerLimits[1][1]) });
              this.state.maxInnerValue = Number(this.innerLimits[1][1]);

              if (suitBetAmt <= Number(this.innerLimits[1][1]) && totBet <= this.props.maxBetAmt) {
                this.suitBet[2] = suitBetAmt;
              }
              break;
            case "heart":
              suitBetAmt = Number((Number(this.suitBet[3]) + Number(this.state.chipVal)).toFixed(2));
              this.setState({ maxInnerValue: this.innerLimits[1][1] });
              this.state.maxInnerValue = Number(this.innerLimits[1][1]);
              if (suitBetAmt <= Number(this.innerLimits[1][1]) && totBet <= this.props.maxBetAmt) {
                this.suitBet[3] = suitBetAmt;
              }
              break;
            case "andar":
              suitBetAmt = Number((Number(this.abBet[0]) + Number(this.state.chipVal)).toFixed(2));
              this.setState({ maxInnerValue: this.innerLimits[0][1] })
              this.state.maxInnerValue = Number(this.innerLimits[0][1]);
              if (suitBetAmt <= Number(this.innerLimits[0][1]) && totBet <= this.props.maxBetAmt) {
                this.abBet[0] = suitBetAmt;
              }
              break;
            case "bahar":
              suitBetAmt = Number((Number(this.abBet[1]) + Number(this.state.chipVal)).toFixed(2));
              this.setState({ maxInnerValue: this.innerLimits[0][1] })
              this.state.maxInnerValue = Number(this.innerLimits[0][1]);
              if (suitBetAmt <= Number(this.innerLimits[0][1]) && totBet <= this.props.maxBetAmt) {
                this.abBet[1] = suitBetAmt;
              }
              break;
            case "eight_k":
              suitBetAmt = Number((Number(this.numBet[1]) + Number(this.state.chipVal)).toFixed(2));
              this.setState({ maxInnerValue: this.innerLimits[2][1] })
              if (suitBetAmt <= Number(this.innerLimits[2][1]) && totBet <= this.props.maxBetAmt) {
                this.numBet[1] = suitBetAmt;
              }
              this.state.maxInnerValue = Number(this.innerLimits[2][1]);
              break;
            case "one_six":
              this.setState({ maxInnerValue: this.innerLimits[2][1] });
              this.state.maxInnerValue = Number(this.innerLimits[2][1]);



              suitBetAmt = Number((Number(this.numBet[0]) + Number(this.state.chipVal)).toFixed(2));

              if (suitBetAmt <= Number(this.innerLimits[2][1]) && totBet <= this.props.maxBetAmt) {
                this.numBet[0] = Number(suitBetAmt);
              }
              break;
          }
          if (suitBetAmt <= this.state.maxInnerValue) {
            // let suitebets = this.changeAmtlabl(suitBetAmt)
            let suitebets = suitBetAmt
            if (id != "andar" && id != "bahar") {
              // document.getElementById(id).innerHTML = `<p class="abc_goldcoin"> <span id=${id + '_cnt'}> ${suitebets} </span> </p>`;
              if (document.getElementById(id)) {
                // document.getElementById(id).appendChild(<div className="abc_goldcoin " style={{ position: "relative" }}><BetPlacedChip betAmount={suitebets} chipString={this.props.abt_chipValues} gameId={24} /></div>)

                const root = ReactDOM.createRoot(document.getElementById(id));
                root.render(<div className="abc_goldcoin " style={{ position: "relative" }}><BetPlacedChip betAmount={suitebets} chipString={this.props.abt_chipValues} gameId={24} /></div>);
              }
            } else {
              // document.getElementById(id).innerHTML = `<p class="abc_goldcoin"> <span id=${id + '_cnt'}> ${suitebets} </span> </p>`;
              if (document.getElementById(id)) {
                // document.getElementById(id).appendChild(<div className="abc_goldcoin " style={{ position: "relative" }}><BetPlacedChip betAmount={suitebets} chipString={this.props.abt_chipValues} gameId={24} /></div>)
                const root = ReactDOM.createRoot(document.getElementById(id));
                root.render(<div className="abc_goldcoin " style={{ position: "relative" }}><BetPlacedChip betAmount={suitebets} chipString={this.props.abt_chipValues} gameId={24} /></div>);
              }
            }
            this.setState({
              totalBetAmount: Number(this.state.totalBetAmount.toFixed(2)) + Number(this.state.chipVal.toFixed(2)),
              totalabbet: Number(this.state.totalBetAmount.toFixed(2)) + Number(this.state.chipVal.toFixed(2)),

              infoText: this.props.language.MinBetAmt + " " + this.props.minBetAmt + " " + this.props.language.MaxBetAmt + " " + this.props.maxBetAmt
            })


          } else {
            let maxInnerLimit = this.changeAmtlabl(this.state.maxInnerValue)
            this.setState({
              infoText: this.props.language.MaxInrBetAmt + maxInnerLimit
            })
          }
        } else {
          this.setState({
            infoText: this.props.language.MinBetAmt + " " + this.props.minBetAmt + " " + this.props.language.MaxBetAmt + " " + this.props.maxBetAmt
            // infoText: this.props.language.AmusementOnly + " " + this.props.language.Min_Bet + " " + this.props.minBetAmt + " " + this.props.language.Max_Bet + " " + this.props.maxBetAmt
          })
        }
      } else {
        this.setState({
          infoText: this.props.language.LowBalance
        })
      }

    } else {
      let currentSuitBetAmt = 0;
      switch (id) {
        case "spade":
          currentSuitBetAmt = Number(this.suitBet[0]);
          this.suitBet[0] = 0;
          break;
        case "club":
          currentSuitBetAmt = Number(this.suitBet[1]);
          this.suitBet[1] = 0;
          break;
        case "dimond":
          currentSuitBetAmt = Number(this.suitBet[2]);
          this.suitBet[2] = 0;
          break;
        case "heart":
          currentSuitBetAmt = Number(this.suitBet[3]);
          this.suitBet[3] = 0;
          break;
        case "andar":
          currentSuitBetAmt = Number(this.abBet[0]);
          this.abBet[0] = 0;
          break;
        case "bahar":
          currentSuitBetAmt = Number(this.abBet[1]);
          this.abBet[1] = 0;
          break;
        case "eight_k":
          currentSuitBetAmt = Number(this.numBet[1]);
          this.numBet[1] = 0;
          break;
        // case "bet_7":
        //   currentSuitBetAmt = Number(this.numBet7);
        //   this.numBet7 = 0;
        //   break;
        case "one_six":
          currentSuitBetAmt = Number(this.numBet[0]);
          this.numBet[0] = 0;
          break;
      }

      let updatedBal = Number(this.state.totalBetAmount - currentSuitBetAmt);
      this.state.totalBetAmount = updatedBal;
      this.setState({
        totalBetAmount: updatedBal,
        totalabbet: updatedBal,
      })

      if (this.state.totalBetAmount == 0) {
        this.disableBtn("clearBtn");
        this.disableBtn("doubleBtn");
        this.setState({
          betButtonText: this.props.language.Prev,
          betButtonValue: 0,
        })
        if (this.props.gameState && this.props.gameState.betRequest && this.props.gameState.betRequest.betAmount > 0) {
          this.enableBtn("betBtn");
          //12
          this.enableBtn("doubleBtn");
        } else {
          this.disableBtn("betBtn");
          //4
          this.disableBtn("doubleBtn");
        }
      }
      // document.getElementById(id).innerHTML = `<p class="abc_goldcoin"> </p>`;
      if (document.getElementById(id)) {
        const root = ReactDOM.createRoot(document.getElementById(id));
        root.render(<div className="abc_goldcoin " style={{ position: "relative" }}></div>);
      }
    }

    if (this.state.totalBetAmount + this.state.chipVal > 0 && this.state.totalBetAmount + this.state.chipVal <= this.props.balance) {
      this.setState({ betButtonText: this.props.language.BetOK, betButtonValue: 1, startBlink: true });
      if (document.getElementById("clearBtn").classList.contains("ab_disBtn")) {
        this.enableBtn("clearBtn");
      }
      if (document.getElementById("doubleBtn").classList.contains("ab_disBtn")) {
        this.enableBtn("doubleBtn");
      }
      if (document.getElementById("betBtn").classList.contains("ab_disBtn")) {
        this.enableBtn("betBtn");
        //11
        this.enableBtn("doubleBtn");
      }
    }

    // if (totalBetAmt <= this.props.balance) {
    //   if (totalBetAmt <= this.props.maxBetAmt) {
    //     // if (suitBetAmt == 0) {
    //     //   document.getElementById(id).innerHTML = `<p class="abc_goldcoin"> </p>`;
    //     // } else {

    //     // }
    //   }
    // }
  }


  clearcardspreviuosglows() {
    this.disableBtn("betBtn");
    //5
    this.disableBtn("doubleBtn");
    this.setState({ disableDealBtn: true });
    document.getElementById("abc_cover").style.display = "block";



    //this.clear_fn();

    document.getElementById("betBtn").style.zIndex = 80;
    this.setState({ btnActive: false });
    document.getElementById("res_andar_Card").style.display = "none";
    document.getElementById("res_bahar_Card").style.display = "none";
    document.getElementById("resJokerCard").style.display = "none";

    const andhar_list = document.getElementById("res_andar_Card");

    this.ab_timeout11 = setTimeout(() => {
      this.setState({
        btnActive: false,
        takeAmount: 0,
        disableDealBtn: false,
        betCard: null,
        startBlink: false,
        isCardsDealing: false,
        enableKeyboard: true,
        isBetSent: false
      }


      )
      this.enableBtn("betBtn");
      //10
      // this.enableBtn("doubleBtn");
      document.getElementById("abc_cover").style.display = "none";
    }, 3000)

    while (andhar_list.hasChildNodes()) {
      andhar_list.removeChild(andhar_list.firstChild);
    }

    const bahar_list = document.getElementById("res_bahar_Card");

    while (bahar_list.hasChildNodes()) {
      bahar_list.removeChild(bahar_list.firstChild);
    }




  }



  changeAmtlabl(chngAmt) {
    let newAmt = Number((chngAmt).toFixed(2));
    if (newAmt >= 1000 && newAmt <= 999999) {
      newAmt = Number((newAmt / 1000).toFixed(2)) + "K";
    } else if (newAmt >= 1000000 && newAmt <= 999999999) {
      newAmt = Number((newAmt / 1000).toFixed(2)) + "M";
    } else if (newAmt > 999999999) {
      newAmt = Number((newAmt / 1000).toFixed(2)) + "B";
    }
    return newAmt;
  }

  handleKeyboard(resp) {
    this.setState({ enableKeyboard: resp });
  }

  selectedCard(id) {
    let totalBetVal = 0;
    if (this.state.totalBetAmount == 0) {
      this.ChipsDealerPlayer.removeWinGlow();
    }

    if (this.state.chipVal != 0) {
      if ((this.state.totalBetAmount + this.state.chipVal) <= this.props.maxBetAmt) {
        totalBetVal += Number(this.state.chipVal);

        if ((Number(this.state.totalBetAmount) + Number(this.state.chipVal)) <= this.props.balance) {
          if (Number((Number(this.cardBet[id]) + Number(this.state.chipVal)).toFixed(2)) <= this.innerLimits[0][1]) {


            // this.cardBetlblchange[id] +=(Number(this.state.chipVal)); 



            // alert(""+this.cardBetlblchange[id])


            this.cardBetAmt = Number((Number(this.cardBetAmt) + Number(this.state.chipVal)).toFixed(2));

            this.cardBet[id] = Number((Number(this.cardBet[id]) + Number(this.state.chipVal)).toFixed(2));
            // let Changebetslbl = this.changeAmtlabl(this.cardBet[id])
            let Changebetslbl = this.cardBet[id]
            this.setState({
              betCard: id,
              betAmt: this.cardBetAmt,
              disable: false,
              infoText: this.props.language.MinBetAmt + " " + this.props.minBetAmt + " " + this.props.language.MaxBetAmt + " " + this.props.maxBetAmt,
              // infoText: this.props.language.AmusementOnly + " " + this.props.language.Min_Bet + " " + this.props.minBetAmt + " " + this.props.language.Max_Bet + " " + this.props.maxBetAmt,
              disableClearBtn: false,
              btnActive: true,
              disableDealBtn: false,
              totalabbet: Number(this.state.totalBetAmount.toFixed(2)) + Number(Number(this.state.chipVal).toFixed(2)),
              totalBetAmount: Number(this.state.totalBetAmount.toFixed(2)) + Number(Number(this.state.chipVal).toFixed(2)),
              betButtonText: this.props.language.BetOK,
              betButtonValue: 1,
              startBlink: true,
            });

            if (document.getElementById("clearBtn").classList.contains("ab_disBtn")) {
              this.enableBtn("clearBtn");
            }
            if (document.getElementById("doubleBtn").classList.contains("ab_disBtn")) {
              this.enableBtn("doubleBtn");
            }
            if (document.getElementById("betBtn").classList.contains("ab_disBtn")) {
              this.enableBtn("betBtn");
              //9
              this.enableBtn("doubleBtn");
            }
            // document.getElementById("fID_" + id).innerHTML = `<p class="abc_goldcoin"> <span> ${cardBetAmt} </span> </p>`;

            // document.getElementById("fID_" + id).innerHTML = `<p class="abc_goldcoin"> <span> ${Changebetslbl} </span> </p>`;


            const container = document.getElementById("fID_" + id);
            if (container) {
              // container.appendChild(<div className="abc_goldcoin " style={{ position: "relative" }}><BetPlacedChip betAmount={Changebetslbl} chipString={this.props.abt_chipValues} gameId={24} /></div>)
              const root = ReactDOM.createRoot(container);
              root.render(<div className="abc_goldcoin " style={{ position: "relative" }}><BetPlacedChip betAmount={Changebetslbl} chipString={this.props.abt_chipValues} gameId={24} /></div>);
            }



            if (document.getElementById("card_" + id))
              document.getElementById("card_" + id).style.transform = "scale(0.9)";

          } else {
            this.setState({
              infoText: this.props.language.MaxInrBetAmt + this.innerLimits[0][1]
            })
          }
        } else {
          this.setState({ infoText: this.props.language.LowBalance });
        }

        if (this.state.betAmt == 0 && this.state.chipVal == 0) {
          // this.setState({ infoText: this.props.language.AmusementOnly + " " + this.props.language.Min_Bet + " " + this.props.minBetAmt + " " + this.props.language.Max_Bet + " " + this.props.maxBetAmt });
          this.setState({ infoText: this.props.language.MinBetAmt + " " + this.props.minBetAmt + " " + this.props.language.MaxBetAmt + " " + this.props.maxBetAmt });
        }
      } else {
        // this.setState({ infoText: this.props.language.AmusementOnly + " " + this.props.language.Min_Bet + " " + this.props.minBetAmt + " " + this.props.language.Max_Bet + " " + this.props.maxBetAmt });
        // this.setState({ infoText: this.props.language.MinBetAmt + " " + this.props.minBetAmt + " " + this.props.language.MaxBetAmt + " " + this.props.maxBetAmt });
      }

    } else {
      if (Number(this.cardBet[id]) > 0) {
        // document.getElementById("fID_" + id).innerHTML = `<p class="abc_goldcoin"/>`;



        const container = document.getElementById("fID_" + id);
        if (container) {
          // container.appendChild(<div className="abc_goldcoin " style={{ position: "relative" }}></div>)
          const root = ReactDOM.createRoot(container);
          root.render(<div className="abc_goldcoin " style={{ position: "relative" }}></div>);
          // root.render(<div className="abc_goldcoin " style={{position:"relative"}}><BetPlacedChip betAmount={Number(bet1_1[id])} chipString={this.props.abt_chipValues} /></div>);
        }



        if (document.getElementById("card_" + id))
          document.getElementById("card_" + id).style.transform = "scale(1)";
        this.setState({
          //betAmt: (Number(this.state.betAmt) - Number(this.cardBet[id])),
          infoText: this.props.language.AmusementOnly,
          disable: true,
          btnActive: false,
          disableClearBtn: true,
          //totalBetAmount: Number(this.state.totalBetAmount) - Number(this.cardBet[id])
        });
        let updatedBal2 = Number(this.state.totalBetAmount) - Number(this.cardBet[id]);
        this.state.totalBetAmount = updatedBal2;
        this.state.totalabbet = updatedBal2;
        totalBetVal = 0;
        this.cardBetAmt = (Number(this.cardBetAmt) - Number(this.cardBet[id]));
        this.cardBet[id] = 0;
        //this.cardBet = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        if (this.state.totalBetAmount == 0) {
          this.disableBtn("clearBtn");
          this.disableBtn("doubleBtn");
          // this.disableBtn("betBtn")
          this.setState({
            betButtonText: this.props.language.Prev,
            betButtonValue: 0,
          })
          if (this.props.gameState && this.props.gameState.betRequest && this.props.gameState.betRequest.betAmount > 0) {
            this.enableBtn("betBtn");
            //7
            this.enableBtn("doubleBtn");
          } else {
            this.disableBtn("betBtn");
            //6
            this.disableBtn("doubleBtn");
          }
        }
      }
    }
  }

  doubleAmount() {
    if (this.state.isGameActive) {
      if (this.state.isGameActive && !this.state.isCardsDealing && this.props.ab_timeSend > 5 && !this.state.isBetSent) {

        if ((this.state.totalBetAmount * 2) <= this.props.balance) {
          let totalSuitAmt = 0;
          let totalNumBet = 0;
          let totalABBet = 0;
         
          if ((this.state.totalBetAmount * 2) <= this.props.maxBetAmt * 2) {

            this.cardBetAmt = 0;

            for (let v = 0; v < this.cardBet.length; v++) {


              if (Number(this.cardBet[v]) > 0) {
                let cardBet = Number(this.cardBet[v] * 2)

                if ((Number((this.cardBet[v] * 2).toFixed(2)) <= this.innerLimits[0][1])) {
                  //this.cardBetAmt = Number(this.cardBetAmt * 2);
                  // let cardBet=this.changeAmtlabl(Number(this.cardBet[v] * 2))
                  this.cardBet[v] = Number((this.cardBet[v] * 2).toFixed(2));
                  // this.cardBet[v] = cardBet;
                  this.cardBetAmt = Number((Number(this.cardBetAmt) + Number(this.cardBet[v])).toFixed(2));
                  // this.cardBet[this.state.betCard] = this.cardBetAmt;
                  if (document.getElementById("fID_" + v)) {
                    // document.getElementById("fID_" + v).innerHTML = `<p class="abc_goldcoin"> <span> ${cardBet} </span> </p>`;



                    const container = document.getElementById("fID_" + v);
                    if (container) {
                      // container.appendChild(<div className="abc_goldcoin " style={{ position: "relative" }}><BetPlacedChip betAmount={cardBet} chipString={this.props.abt_chipValues} gameId={24} /></div>)
                      let root = ReactDOM.createRoot(document.getElementById("fID_" + v));
                      root.render(<div className="abc_goldcoin " style={{ position: "relative" }}><BetPlacedChip betAmount={cardBet} chipString={this.props.abt_chipValues} gameId={24} /></div>);
                      // root.render(<div className="abc_goldcoin " style={{position:"relative"}}></div>);
                    }
                    if (document.getElementById("card_" + v)) {

                      document.getElementById("card_" + v).style.transform = "scale(0.9)";
                    }
                  }
                } else {
                  this.cardBetAmt = Number((Number(this.cardBetAmt) + Number(this.cardBet[v])).toFixed(2));
                }
              } else {
                // this.setState({ infoText: this.props.language.Min_Bet + " " + this.props.minBetAmt + " " + this.props.language.Max_Bet + " " + this.props.maxBetAmt })
                this.setState({ infoText: this.props.language.MinBetAmt + " " + this.props.minBetAmt + " " + this.props.language.MaxBetAmt + " " + this.props.maxBetAmt })



              }
            }


            for (let k = 0; k < this.suitBet.length; k++) {
              if (this.suitBet[k] > 0) {
                if (Number((this.suitBet[k] * 2).toFixed(2)) <= this.innerLimits[1][1]) {
                  this.suitBet[k] = Number((this.suitBet[k] * 2).toFixed(2));
                  let suitBet = this.changeAmtlabl(Number(this.suitBet[k]))
                  switch (k) {
                    case 0:
                      // document.getElementById("spade").innerHTML = `<p class="abc_goldcoin"> <span> ${suitBet} </span> </p>`;

                      if (document.getElementById("spade")) {
                        // document.getElementById("spade").appendChild(<div className="abc_goldcoin " style={{ position: "relative" }}><BetPlacedChip betAmount={suitBet} chipString={this.props.abt_chipValues} gameId={24} /></div>)
                        const root = ReactDOM.createRoot(document.getElementById("spade"));
                        root.render(<div className="abc_goldcoin " style={{ position: "relative" }}><BetPlacedChip betAmount={suitBet} chipString={this.props.abt_chipValues} gameId={24} /></div>);
                      }
                      break;
                    case 1:
                      // document.getElementById("club").innerHTML = `<p class="abc_goldcoin"> <span> ${suitBet} </span> </p>`;
                      if (document.getElementById("club")) {
                        // document.getElementById("club").appendChild(<div className="abc_goldcoin " style={{ position: "relative" }}><BetPlacedChip betAmount={suitBet} chipString={this.props.abt_chipValues} gameId={24} /></div>)
                        const root = ReactDOM.createRoot(document.getElementById("club"));
                        root.render(<div className="abc_goldcoin " style={{ position: "relative" }}><BetPlacedChip betAmount={suitBet} chipString={this.props.abt_chipValues} gameId={24} /></div>);
                      }
                      break;
                    case 2:
                      // document.getElementById("dimond").innerHTML = `<p class="abc_goldcoin"> <span> ${suitBet} </span> </p>`;
                      if (document.getElementById("dimond")) {
                        // document.getElementById("dimond").appendChild(<div className="abc_goldcoin " style={{ position: "relative" }}><BetPlacedChip betAmount={suitBet} chipString={this.props.abt_chipValues} gameId={24} /></div>)
                        const root = ReactDOM.createRoot(document.getElementById("dimond"));
                        root.render(<div className="abc_goldcoin " style={{ position: "relative" }}><BetPlacedChip betAmount={suitBet} chipString={this.props.abt_chipValues} gameId={24} /></div>);
                      }
                      break;
                    case 3:
                      // document.getElementById("heart").innerHTML = `<p class="abc_goldcoin"> <span> ${suitBet} </span> </p>`;
                      if (document.getElementById("heart")) {
                        // document.getElementById("heart").appendChild(<div className="abc_goldcoin " style={{ position: "relative" }}><BetPlacedChip betAmount={suitBet} chipString={this.props.abt_chipValues} gameId={24} /></div>)
                        const root = ReactDOM.createRoot(document.getElementById("heart"));
                        root.render(<div className="abc_goldcoin " style={{ position: "relative" }}><BetPlacedChip betAmount={suitBet} chipString={this.props.abt_chipValues} gameId={24} /></div>);
                      }
                      break;
                  }
                  totalSuitAmt = Number((Number(totalSuitAmt) + Number(this.suitBet[k])).toFixed(2));
                } else {
                  totalSuitAmt = Number((Number(totalSuitAmt) + Number(this.suitBet[k])).toFixed(2));
                }
              } else {
                totalSuitAmt = Number((Number(totalSuitAmt) + Number(this.suitBet[k])).toFixed(2));
                // this.setState({ infoText: this.props.language.Min_Bet + " " + this.props.minBetAmt + " " + this.props.language.Max_Bet + " " + this.props.maxBetAmt })
                this.setState({ infoText: this.props.language.MinBetAmt + " " + this.props.minBetAmt + " " + this.props.language.MaxBetAmt + " " + this.props.maxBetAmt })
              }
            }

            for (let m = 0; m < this.abBet.length; m++) {
              // let abBet=this.changeAmtlabl(Number(this.abBet[m] * 2))
              if (this.abBet[m] > 0) {
                if (Number((this.abBet[m] * 2).toFixed(2)) <= this.innerLimits[0][1]) {
                  this.abBet[m] = Number((this.abBet[m] * 2).toFixed(2));
                  let abBet = Number(this.abBet[m])
                  // this.abBet[m] = abBet;
                  if (m == 0) {
                    // document.getElementById("andar").innerHTML = `<p class="abc_goldcoin"> <span> ${abBet} </span> </p>`;
                    if (document.getElementById("andar")) {
                      // document.getElementById("andar").appendChild(<div className="abc_goldcoin " style={{ position: "relative" }}><BetPlacedChip betAmount={abBet} chipString={this.props.abt_chipValues} gameId={24} /></div>)
                      const root = ReactDOM.createRoot(document.getElementById("andar"));
                      root.render(<div className="abc_goldcoin " style={{ position: "relative" }}><BetPlacedChip betAmount={abBet} chipString={this.props.abt_chipValues} gameId={24} /></div>);
                    }
                  } else {
                    // document.getElementById("bahar").innerHTML = `<p class="abc_goldcoin"> <span> ${abBet} </span> </p>`;
                    if (document.getElementById("bahar")) {
                      // document.getElementById("bahar").appendChild(<div className="abc_goldcoin " style={{ position: "relative" }}><BetPlacedChip betAmount={abBet} chipString={this.props.abt_chipValues} gameId={24} /></div>)
                      const root = ReactDOM.createRoot(document.getElementById("bahar"));
                      root.render(<div className="abc_goldcoin " style={{ position: "relative" }}><BetPlacedChip betAmount={abBet} chipString={this.props.abt_chipValues} gameId={24} /></div>);
                    }
                  }
                  totalABBet = Number((Number(totalABBet) + Number(this.abBet[m])).toFixed(2));
                } else {
                  totalABBet = Number((Number(totalABBet) + Number(this.abBet[m])).toFixed(2));
                }
              } else {
                totalABBet = Number((Number(totalABBet) + Number(this.abBet[m])).toFixed(2));
                // this.setState({ infoText: this.props.language.Min_Bet + " " + this.props.minBetAmt + " " + this.props.language.Max_Bet + " " + this.props.maxBetAmt })
                this.setState({ infoText: this.props.language.MinBetAmt + " " + this.props.minBetAmt + " " + this.props.language.MaxBetAmt + " " + this.props.maxBetAmt })

              }
            }

            for (let j = 0; j < this.numBet.length; j++) {

              if (this.numBet[j] > 0 && Number((this.numBet[j] * 2).toFixed(2)) <= this.innerLimits[2][1]) {
                this.numBet[j] = Number((this.numBet[j] * 2).toFixed(2));
                let numBet = Number(this.numBet[j])

                //  this.numBet[j] = numBet;

                if (j == 0) {
                  // document.getElementById("one_six").innerHTML = `<p class="abc_goldcoin"> <span> ${numBet} </span> </p>`;
                  if (document.getElementById("one_six")) {
                    // document.getElementById("one_six").appendChild(<div className="abc_goldcoin " style={{ position: "relative" }}><BetPlacedChip betAmount={numBet} chipString={this.props.abt_chipValues} gameId={24} /></div>)
                    const root = ReactDOM.createRoot(document.getElementById("one_six"));
                    root.render(<div className="abc_goldcoin " style={{ position: "relative" }}><BetPlacedChip betAmount={numBet} chipString={this.props.abt_chipValues} gameId={24} /></div>);
                  }
                } else {
                  // document.getElementById("eight_k").innerHTML = `<p class="abc_goldcoin"> <span> ${numBet} </span> </p>`;
                  if (document.getElementById("eight_k")) {
                    // document.getElementById("eight_k").appendChild(<div className="abc_goldcoin " style={{ position: "relative" }}><BetPlacedChip betAmount={numBet} chipString={this.props.abt_chipValues} gameId={24} /></div>)
                    const root = ReactDOM.createRoot(document.getElementById("eight_k"));
                    root.render(<div className="abc_goldcoin " style={{ position: "relative" }}><BetPlacedChip betAmount={numBet} chipString={this.props.abt_chipValues} gameId={24} /></div>);
                  }
                }
                totalNumBet = Number((Number(totalNumBet) + Number(this.numBet[j])).toFixed(2));
              } else {
                totalNumBet = Number((Number(totalNumBet) + Number(this.numBet[j])).toFixed(2));

                if (this.state.totalBetAmount * 2 > this.innerLimits[0][1]) {
                  this.setState({
                    infoText: this.props.language.MaxInrBetAmt + this.innerLimits[0][1]
                  })
                } else {

                  this.setState({ infoText: this.props.language.MinBetAmt + " " + this.props.minBetAmt + " " + this.props.language.MaxBetAmt + " " + this.props.maxBetAmt });
                }
              }
            }

            this.setState({
              totalabbet: Number(Number(totalSuitAmt.toFixed(2)) + Number(totalABBet.toFixed(2)) + Number(totalNumBet.toFixed(2)) + Number(this.cardBetAmt.toFixed(2))),
              totalBetAmount: Number(Number(totalSuitAmt.toFixed(2)) + Number(totalABBet.toFixed(2)) + Number(totalNumBet.toFixed(2)) + Number(this.cardBetAmt.toFixed(2)))
            })
          } else {
            this.setState({
              infoText: this.props.language.MinBetAmt + " " + this.props.minBetAmt + " " + this.props.language.MaxBetAmt + " " + this.props.maxBetAmt
              // infoText: this.props.language.Min_Bet + " " + this.props.minBetAmt + " " + this.props.language.Max_Bet + " " + this.props.maxBetAmt
            })
          }
          if (totalABBet > this.innerLimits[0][1]) {
            this.setState({
              infoText: this.props.language.MaxInrBetAmt + this.innerLimits[0][1]
            })
          }
        } else {
          this.setState({ infoText: this.props.language.LowBalance, disable: true });
        }



      }
    }
  }

  updateMessage = () => {
    this.setState({ infoText: this.props.infoText });


    if (this.props.error_code == "game.bet.invalid") {
      this.clear_fn();
      this.setState({
        betButtonText: this.props.language.Prev,
        betButtonValue: 0,
        btnActive: false,
        disBetBtn: 0,
        isBetSent: false,
        infoText: this.props.language.InvalidBet
      });

      document.getElementById('abc_cover').style.display = 'none';
      if (this.props.gameState && this.props.gameState.betRequest && this.props.gameState.betRequest.betAmount > 0) {
        this.setState({ disableDealBtn: false, })
        this.enableBtn("betBtn");
        //8
        this.enableBtn("doubleBtn");
      }
    } else if (this.props.error_code == "game.bet.accepted") {
      this.setState({ isBetSent: true, enableKeyboard: false })
    }
  }



  updateHistory(hisData) {
    this.ChipsDealerPlayer.updateHistory(this.props.gameState.history);
  }

  andarBaharTimerGetResp() {
    this.resultShown = true;
    if (document.getElementById('abc_cover')) {
      // document.getElementById('abc_cover').style.zIndex = 190;
      document.getElementById('abc_cover').style.zIndex = 10000;
      document.getElementById('abc_cover').style.display = 'block';
    }

    this.disableBtn("clearBtn");
    this.disableBtn("doubleBtn");
    this.disableBtn("betBtn");
    this.setState({ enableKeyboard: false, isCardsDealing: true });

    if (this.ChipsDealerPlayer) {
      this.ChipsDealerPlayer.updateResult(this.props.andarBaharTimerResult);
    }
    if (this.TopLable) {
      this.TopLable.updateResStatus();
    }
  }


  topLable_fn(Value) {
    let labelValue = Math.abs(Number(Value))
    // Nine Zeroes for Billions
    return labelValue >= 1.0e+9

      ? Number((labelValue / 1.0e+9).toFixed(2)) + "B"
      // Six Zeroes for Millions 
      : labelValue >= 1.0e+6

        ? Number((labelValue / 1.0e+6).toFixed(2)) + "M"
        // Three Zeroes for Thousands
        : labelValue >= 1.0e+3

          ? Number((labelValue / 1.0e+3).toFixed(2)) + "K"

          : Number(labelValue.toFixed(2));
  }

  handleImageLoad = () => {
    const { assestsLoaderFunction } = this.props;
    assestsLoaderFunction()
  }
  closeWin() {
    document.getElementById('iospopup').style.display = "none";
    this.takeSound = new Audio(takeSound);
    this.winSound = new Audio(winSound);
    this.clearSound = new Audio(clearSound);
    this.ChipsDealerPlayer.closePop()
    this.playVideo()
  }

  playVideo() {
    // console.log("Welcome Video Play Video Started")
    const iosPopup = document.getElementById('iospopup');

    if (
      !this.state.totalBetAmount &&
      iosPopup &&
      iosPopup.style.display === "none" &&
      this.backgroudFrame === 0
    ) {
      // Clear any existing animation

      // console.log("Welcome Video If Condition Passed")
      if (this.isSpritePlaying) {
        // console.log("Welcome Video already playing — skipping duplicate start");
        return;
      }

      const SPRITE_SHEET_WIDTH = 7575;
      const SPRITE_SHEET_HEIGHT = 4309;
      const COLUMNS = 14;
      const ROWS = 14;
      const TOTAL_FRAMES = 192;

      const FRAME_WIDTH = (SPRITE_SHEET_WIDTH / COLUMNS) + 0.5;
      const FRAME_HEIGHT = SPRITE_SHEET_HEIGHT / ROWS;

      // Function to start the sprite animation after both audio and image are loaded
      const startSpriteAnimation = () => {
        // console.log("Welcome Video Start Sprite Animation")
        this.backgroudFrame = 0;
        this.isSpritePlaying = true;
        if (this.spriteInterval) {
          clearInterval(this.spriteInterval);
          this.spriteInterval = null;
        }
        // First check if the audio is already loaded
        if (this.welComeVideoAudio.state() === 'loaded') {
          // Both audio and image are loaded, start animation
          // console.log("Welcome Video Audio is Loaded")


          // Set showVideo to true when the video actually starts
          this.setState({ showVideo: true, welComeSpriteImage: this.welComeSpriteImage.src }, () => {


            this.spriteInterval = setInterval(() => {
              if (this.backgroudFrame >= TOTAL_FRAMES) {
                // console.log("Welcome Video Clear Interval", this.backgroudFrame, TOTAL_FRAMES);

                clearInterval(this.spriteInterval);
                this.spriteInterval = null;
                this.isSpritePlaying = false;

                this.setState({
                  backGroundX: "0",
                  backGroundY: "0",
                  showVideo: false // Hide video once animation is complete
                });

                this.backgroudFrame = 0;
                return;
              }

              const col = this.backgroudFrame % COLUMNS;
              const row = Math.floor(this.backgroudFrame / COLUMNS);
              const x = -(col * FRAME_WIDTH);
              const y = -(row * FRAME_HEIGHT);

              this.setState({
                backGroundX: `${x}`,
                backGroundY: `${y}`
              }, () => {
                // console.log("Welcome Video Background Frame", this.backgroudFrame)
                if (this.backgroudFrame === 0) {
                  this.welComeVideoAudio.stop();
                  this.welComeVideoAudio.play();
                }
              });

              this.backgroudFrame++;
            }, 41); // ~24 fps
          });

        } else {
          // Wait until audio is loaded
          this.welComeVideoAudio.once('load', startSpriteAnimation);
        }
      };

      // Wait for the image to load before checking the audio
      // this.welComeSpriteImage.onload = () => {
      //   console.log("Welcome Video On Load");

      //   startSpriteAnimation(); // Once image is loaded, check audio and start animation
      // };

      // If image is already loaded, start the animation
      if (this.welComeSpriteImage.complete) {
        // console.log("Welcome Video On Complete");
        startSpriteAnimation();
      }
    }
  }

  stopVideo() {
    // Only stop if something is playing
    if (this.isSpritePlaying) {
      // Stop the sprite animation
      if (this.spriteInterval) {
        clearInterval(this.spriteInterval);
        this.spriteInterval = null;
      }

      // Stop the audio if it's playing
      if (this.welComeVideoAudio) {
        this.welComeVideoAudio.stop();
      }

      // Reset states
      this.isSpritePlaying = false;
      this.backgroudFrame = 0;

      this.setState({
        backGroundX: "0",
        backGroundY: "0",
        showVideo: false
      });

      // Optional: console.log("Welcome Video stopped manually");
    }
  }

  render() {

    const roundNumber = this.props.balance - this.state.totalabbet
    const betAmount = roundNumber;
    // let updatebal = this.topLable_fn(betAmount);  
    // let updateBet = this.topLable_fn(this.state.totalBetAmount)

    let updatebal = Number(betAmount.toFixed(2));
    let updateBet = Number(this.state.totalBetAmount.toFixed(2))
    let winAmount = this.state.takeAmount !== undefined ? (this.state.takeAmount) : null
    return (
      <React.Fragment>
        <div className="gameBox" id="gameBox">


          <div className="iosFetchSounds" id="iospopup" onClick={(e) => this.closeWin()}>
            <div className="popupTooLong">
              <div className=""> {this.props.language.Wel_ABC} </div>
              <br></br>
              {this.props.language.OK_Btn}
              <br></br>
              <br></br>
              <div className="fd">
                <button className="btn_iosPopup" onClick={(e) => this.closeWin()} > {this.props.language.Ok} </button>
                <br></br>
              </div>
            </div>
          </div>

          <div className="andarBaharbg abc_bg">
            {/* {this.state.showVideo && */}
            {/* <div className="ABC_welcomeVideo" style={{ "--backgroundImage": `url(${this.state.welComeSpriteImage})`, "--backGroundX": `${this.state.backGroundX}px`, "--backGroundY": `${this.state.backGroundY}px`, display: this.state.showVideo ? "block" : "none" }}>
            </div> */}
            {/* } */}
            <img src={ad_bg_img} alt="Hidden Loader" className="hidden" onLoad={this.handleImageLoad} />
            <TopLable
              childRef={ref => (this.TopLable = ref)}
              playerId={this.props.playerId}
              ref={this.TopLable}
              updatedbalance={updatebal}
              updatedwinAmt={winAmount}

              funCardGameState={this.props.funCardGameState}
              betAmt={this.state.betAmt}
              balance={this.props.balance}
              user={this.props.user}
              gameEntry={this.props.gameEntry}
              language={this.props.language}
              takeAmount={this.state.takeAmount}
              gameState={this.props.gameState}
              auto_bet={this.auto_bet.bind(this)}
              check_spec={this.check_spec.bind(this)}
              disableBtns={this.disableBtns.bind(this)}
              network={this.props.network}
              gameId={this.props.gameId}
              winGlowImg={this.state.winGlowImg}
            />

            <ChipsDealerPlayer
              childRef={ref => (this.ChipsDealerPlayer = ref)}
              delearFirst={this.state.delearFirst}
              updatedbets={updateBet}
              cardsArray={this.state.cardsArray}
              betAmountArray={this.state.betAmountArray}
              winnerArray={this.state.winnerArray}
              funCardGameState={this.props.funCardGameState}
              funCardResult={this.state.targetResult}
              ref={this.ChipsDealerPlayer}
              enableKeyboard={this.handleKeyboard.bind(this)}
              selectedCard={this.selectedCard.bind(this)}
              getChipVal={this.getChipVal.bind(this)}
              disableClearBtn={this.state.disableClearBtn}
              disableDealBtn={this.state.disableDealBtn}
              disable={this.state.disable}
              btnActive={this.state.btnActive}
              betBtnTxt={this.state.betButtonText}
              betButtonValue={this.state.betButtonValue}
              betCard={this.state.betCard}
              doubleAmount={this.doubleAmount.bind(this)}
              infoText={this.state.infoText}
              action={this.gameCloseHandler.bind(this)}
              bet_fn={this.bet_fn.bind(this)}
              clear_fn={this.clear_fn.bind(this)}
              selecteSuit={this.selecteSuit.bind(this)}
              totalBetAmount={this.state.totalBetAmount}
              totalabbet={this.state.totalabbet}
              network={this.props.network}
              disableBetBtn={this.state.disableBetBtn}
              isMobile={this.props.isMobile}
              declare_Result={this.declare_Result.bind(this)}
              startBlink={this.state.startBlink}
              gameState={this.props.gameState}
              abt_chipValues={this.props.abt_chipValues}
              playVideo={this.playVideo}
              isBetSent={this.state.isBetSent}
            />
          </div>
          <div id="abc_cover" className="abc_cover">
          </div>
          <div className="winPopandb winPopabc" id="winPopandb">
            <div className="popBorderandb">
              {this.props.language.Win_Amt}  &nbsp; <span> {winAmount} </span>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatesToProps = (state) => {
  return {
    language: state.languageObjs.languageObj

  }
}
export default connect(mapStatesToProps)(AndarBaharClassic)